"use strict";
Object.defineProperties(exports, { __esModule: { value: true }, [Symbol.toStringTag]: { value: "Module" } });
const vue = require("vue");
const arrowRight = require("../arrow-right-12d165a9.js");
const chevronLeft = require("../chevron-left-2147e244.js");
const search = require("../search-b41e3b7b.js");
const close = require("../close-d4326b17.js");
const burger = require("../burger-56a8c670.js");
const play = require("../play-465a60ac.js");
const upload = require("../upload-adad3b8e.js");
const _hoisted_1$O = {
  fill: "none",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$O = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m17.943 9-1.886-1.885-8.942 8.942L16.057 25l1.886-1.885-5.724-5.724H25v-2.667H12.219L17.943 9z",
  fill: "currentcolor"
}, null, -1);
const _hoisted_3$N = [
  _hoisted_2$O
];
function render$O(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$O, _hoisted_3$N);
}
const ArrowLeft = { render: render$O };
const _hoisted_1$N = {
  fill: "none",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$N = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M19.304 21.97h2.666V9.323H9.323v2.667h8.095l-9.037 9.037 1.885 1.886 9.038-9.038v8.095z",
  fill: "currentcolor"
}, null, -1);
const _hoisted_3$M = [
  _hoisted_2$N
];
function render$N(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$N, _hoisted_3$M);
}
const ArrowAngle = { render: render$N };
const _hoisted_1$M = {
  fill: "none",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$M = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m8.357 11 7.155 6.593L22.667 11l2.356 2.172-9.511 8.764L6 13.172 8.357 11z",
  fill: "currentcolor"
}, null, -1);
const _hoisted_3$L = [
  _hoisted_2$M
];
function render$M(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$M, _hoisted_3$L);
}
const ChevronDown = { render: render$M };
const _hoisted_1$L = {
  fill: "none",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$L = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m22.667 21.936-7.155-6.593-7.155 6.593L6 19.765 15.512 11l9.511 8.765-2.356 2.171z",
  fill: "currentcolor"
}, null, -1);
const _hoisted_3$K = [
  _hoisted_2$L
];
function render$L(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$L, _hoisted_3$K);
}
const ChevronUp = { render: render$L };
const _hoisted_1$K = {
  fill: "none",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$K = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M8.89 14.147 7 16.046l8.963 8.922 8.963-9.005-1.89-1.88-5.737 5.763V7.035l-2.672.012v12.811l-5.737-5.71z",
  fill: "currentcolor"
}, null, -1);
const _hoisted_3$J = [
  _hoisted_2$K
];
function render$K(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$K, _hoisted_3$J);
}
const ArrowDown = { render: render$K };
const _hoisted_1$J = {
  fill: "none",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$J = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m23.036 17.856 1.89-1.899-8.963-8.922L7 16.04l1.89 1.88 5.737-5.763v12.811l2.672-.012V12.145l5.737 5.71z",
  fill: "currentcolor"
}, null, -1);
const _hoisted_3$I = [
  _hoisted_2$J
];
function render$J(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$J, _hoisted_3$I);
}
const ArrowUp = { render: render$J };
const _hoisted_1$I = {
  width: "1200",
  height: "1227",
  viewBox: "0 0 1200 1227",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$I = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M714.163 519.284 1160.89 0h-105.86L667.137 450.887 357.328 0H0l468.492 681.821L0 1226.37h105.866l409.625-476.152 327.181 476.152H1200L714.137 519.284h.026ZM569.165 687.828l-47.468-67.894-377.686-540.24h162.604l304.797 435.991 47.468 67.894 396.2 566.721H892.476L569.165 687.854v-.026Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$H = [
  _hoisted_2$I
];
function render$I(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$I, _hoisted_3$H);
}
const TwitterIcon = { render: render$I };
const _hoisted_1$H = {
  fill: "none",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$H = /* @__PURE__ */ vue.createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M1.333 3.784a2.454 2.454 0 0 1 2.451-2.451h24.43a2.46 2.46 0 0 1 1.734.716 2.456 2.456 0 0 1 .719 1.735v24.43a2.456 2.456 0 0 1-1.514 2.266 2.453 2.453 0 0 1-.938.187H3.784a2.457 2.457 0 0 1-2.265-1.514 2.456 2.456 0 0 1-.186-.938V3.784zm11.611 8.733h3.972v1.995c.573-1.147 2.04-2.179 4.244-2.179 4.225 0 5.227 2.284 5.227 6.475v7.763H22.11v-6.808c0-2.387-.574-3.734-2.03-3.734-2.02 0-2.86 1.452-2.86 3.734v6.808h-4.277V12.517zM5.611 26.388h4.277V12.333H5.611v14.055zM10.5 7.749a2.742 2.742 0 0 1-.784 1.984 2.744 2.744 0 0 1-1.966.828A2.757 2.757 0 0 1 5.192 8.82 2.748 2.748 0 0 1 7.75 5.059a2.748 2.748 0 0 1 2.75 2.69z",
  fill: "currentcolor",
  "fill-rule": "evenodd"
}, null, -1);
const _hoisted_3$G = [
  _hoisted_2$H
];
function render$H(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$H, _hoisted_3$G);
}
const LinkedinIcon = { render: render$H };
const _hoisted_1$G = {
  fill: "none",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$G = /* @__PURE__ */ vue.createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M0 16.09C0 24.043 5.777 30.658 13.333 32V20.444h-4V16h4v-3.556c0-4 2.578-6.221 6.223-6.221 1.155 0 2.4.177 3.555.354v4.09h-2.044c-1.956 0-2.4.977-2.4 2.222V16h4.266l-.71 4.444h-3.556V32C26.223 30.659 32 24.045 32 16.09 32 7.24 24.8 0 16 0S0 7.24 0 16.09z",
  fill: "currentcolor",
  "fill-rule": "evenodd"
}, null, -1);
const _hoisted_3$F = [
  _hoisted_2$G
];
function render$G(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$G, _hoisted_3$F);
}
const FacebookIcon = { render: render$G };
const _hoisted_1$F = {
  fill: "none",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$F = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M16 28a12 12 0 1 0 .002-23.999A12 12 0 0 0 16 28zm0-22c.748 0 1.75.712 2.626 2.636.188.416.362.872.52 1.364h-6.292c.146-.464.32-.92.52-1.364C14.25 6.712 15.254 6 16 6zm-4.446 1.808c-.3.664-.566 1.4-.786 2.192H8a10.028 10.028 0 0 1 4.076-3.2 10.92 10.92 0 0 0-.522 1.008zM10.326 12A24.04 24.04 0 0 0 10 16c0 1.398.114 2.746.326 4H6.832A9.974 9.974 0 0 1 6 16a9.95 9.95 0 0 1 .832-4h3.494zm.442 10c.22.792.484 1.528.786 2.192.158.348.332.686.52 1.008A10.03 10.03 0 0 1 8 22h2.768zm2.086 0h6.292c-.146.465-.32.92-.52 1.364C17.75 25.288 16.746 26 16 26c-.748 0-1.75-.712-2.626-2.636-.2-.444-.374-.9-.52-1.364zm6.788-2H12.36a21.903 21.903 0 0 1-.36-4c0-1.428.128-2.78.358-4h7.282c.23 1.22.358 2.572.358 4s-.128 2.78-.358 4h.002zm1.59 2H24a10.028 10.028 0 0 1-4.076 3.2c.19-.322.364-.66.52-1.008.304-.664.568-1.4.788-2.192zm3.936-2h-3.494c.22-1.322.329-2.66.326-4 0-1.398-.114-2.744-.326-4h3.494A9.95 9.95 0 0 1 26 16a9.95 9.95 0 0 1-.832 4zM19.924 6.8A10.041 10.041 0 0 1 24 10h-2.768a15.06 15.06 0 0 0-.786-2.192c-.156-.345-.33-.681-.52-1.008h-.002z",
  fill: "currentcolor"
}, null, -1);
const _hoisted_3$E = [
  _hoisted_2$F
];
function render$F(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$F, _hoisted_3$E);
}
const GlobeIcon = { render: render$F };
const _hoisted_1$E = {
  fill: "none",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$E = /* @__PURE__ */ vue.createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M26.482 9.658 15.01 24 6 16.49l1.7-2.04 6.928 5.773L24.41 8l2.073 1.658z",
  fill: "currentcolor",
  "fill-rule": "evenodd"
}, null, -1);
const _hoisted_3$D = [
  _hoisted_2$E
];
function render$E(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$E, _hoisted_3$D);
}
const TickIcon = { render: render$E };
const _hoisted_1$D = {
  fill: "none",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$D = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M27.614 17.114v-2.228h-10.5v-10.5h-2.228v10.5h-10.5v2.228h10.5v10.5h2.228v-10.5h10.5z",
  fill: "currentcolor"
}, null, -1);
const _hoisted_3$C = [
  _hoisted_2$D
];
function render$D(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$D, _hoisted_3$C);
}
const PlusIcon = { render: render$D };
const _hoisted_1$C = {
  fill: "none",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$C = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M24.198 30.336a4.088 4.088 0 0 1-.869-.096 29.435 29.435 0 0 1-14.43-7.597 28.405 28.405 0 0 1-7.815-14.11 3.973 3.973 0 0 1 1.173-3.715L5.73 1.475a1.734 1.734 0 0 1 1.337-.469 1.742 1.742 0 0 1 1.259.755l4.341 6.417a1.387 1.387 0 0 1-.096 1.65l-2.179 2.604a16.453 16.453 0 0 0 3.62 5.114 16.704 16.704 0 0 0 5.271 3.551l2.7-2.144a1.423 1.423 0 0 1 1.615-.104l6.556 4.237a1.738 1.738 0 0 1 .356 2.7l-3.387 3.351a4.102 4.102 0 0 1-2.925 1.199zM6.928 2.726 3.455 6.067a2.197 2.197 0 0 0-.652 2.084 26.666 26.666 0 0 0 7.303 13.25 27.692 27.692 0 0 0 13.58 7.145 2.387 2.387 0 0 0 2.17-.642l3.386-3.352-6.33-4.09-2.9 2.31a.862.862 0 0 1-.798.148 17.42 17.42 0 0 1-6.39-4.124 16.936 16.936 0 0 1-4.23-6.252.874.874 0 0 1 .209-.825l2.345-2.804-4.22-6.19z",
  fill: "currentcolor"
}, null, -1);
const _hoisted_3$B = [
  _hoisted_2$C
];
function render$C(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$C, _hoisted_3$B);
}
const PhoneIcon = { render: render$C };
const _hoisted_1$B = {
  fill: "none",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$B = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M26.667 7H5.333C4.597 7 4 7.597 4 8.333v16c0 .737.597 1.334 1.333 1.334h21.334c.736 0 1.333-.597 1.333-1.334v-16C28 7.597 27.403 7 26.667 7z",
  stroke: "currentcolor",
  "stroke-linecap": "round",
  "stroke-width": "2"
}, null, -1);
const _hoisted_3$A = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m4 9 12 7.333L28 9",
  stroke: "currentcolor",
  "stroke-linecap": "round",
  "stroke-width": "2"
}, null, -1);
const _hoisted_4$a = [
  _hoisted_2$B,
  _hoisted_3$A
];
function render$B(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$B, _hoisted_4$a);
}
const EmailIcon = { render: render$B };
const _hoisted_1$A = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
};
const _hoisted_2$A = /* @__PURE__ */ vue.createElementVNode("path", {
  fill: "currentcolor",
  "fill-rule": "evenodd",
  d: "M26.402 3.968h-9.014v2h7.582l-11 10.89 1.407 1.422L26.402 7.365v7.526h2V3.968h-2zM6 7.994h1.997V25.97H6V7.994zm1.997 0h6.988v1.997H7.997V7.994zM22.972 25.97H7.997v-1.997h14.975v-6.99h1.997v8.987h-1.997z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3$z = [
  _hoisted_2$A
];
function render$A(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$A, _hoisted_3$z);
}
const LinkoutIcon = { render: render$A };
const _hoisted_1$z = {
  fill: "none",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$z = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M15.897 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
  stroke: "currentcolor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2"
}, null, -1);
const _hoisted_3$y = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M23.897 15c-3 7-8 15-8 15s-5-8-8-15 2-13 8-13 11 6 8 13z",
  stroke: "currentcolor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2"
}, null, -1);
const _hoisted_4$9 = [
  _hoisted_2$z,
  _hoisted_3$y
];
function render$z(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$z, _hoisted_4$9);
}
const PinIcon = { render: render$z };
const _hoisted_1$y = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
};
const _hoisted_2$y = /* @__PURE__ */ vue.createElementVNode("path", {
  fill: "currentcolor",
  "fill-rule": "evenodd",
  d: "m25.7 9.3-7-7c-.2-.2-.4-.3-.7-.3H8c-1.1 0-2 .9-2 2v24c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V10c0-.3-.1-.5-.3-.7zM18 4.4l5.6 5.6H18V4.4zM24 28H8V4h8v6c0 1.1.9 2 2 2h6v16zm-2-6v2H10v-2h12zm0-4v-2H10v2h12z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3$x = [
  _hoisted_2$y
];
function render$y(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$y, _hoisted_3$x);
}
const DocumentIcon = { render: render$y };
const _hoisted_1$x = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$x = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m7.532 17.718 4.945-5.367-4.945-5.366 1.629-1.767 6.574 7.133-6.574 7.134-1.629-1.767z",
  fill: "currentcolor"
}, null, -1);
const _hoisted_3$w = [
  _hoisted_2$x
];
function render$x(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$x, _hoisted_3$w);
}
const RightIcon = { render: render$x };
const _hoisted_1$w = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$w = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12Zm0 2c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14Zm-1.5-6V14h3v10h-3ZM16 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$v = [
  _hoisted_2$w
];
function render$w(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$w, _hoisted_3$v);
}
const InfoCircleIcon = { render: render$w };
const _hoisted_1$v = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
};
const _hoisted_2$v = /* @__PURE__ */ vue.createElementVNode("path", { d: "M400 288H48c-17.69 0-32-14.32-32-32.01S30.31 224 48 224h352c17.69 0 32 14.3 32 31.99S417.7 288 400 288z" }, null, -1);
const _hoisted_3$u = [
  _hoisted_2$v
];
function render$v(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$v, _hoisted_3$u);
}
const MinusIcon = { render: render$v };
const _hoisted_1$u = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$u = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M26.302 24.245c.25.08.492.181.725.3.356.181.674.412.973.668V11.4c0-1.17-.003-1.886-.06-2.414a2.461 2.461 0 0 0-.086-.472.34.34 0 0 0-.045-.101 1 1 0 0 0-.221-.222c-.007-.005-.03-.022-.102-.045a2.467 2.467 0 0 0-.472-.086C26.486 8.003 25.77 8 24.6 8H7.4c-1.17 0-1.886.003-2.414.06-.246.027-.39.06-.472.086-.072.023-.095.04-.101.045-.085.061-.16.136-.222.221-.005.007-.022.03-.045.102-.026.083-.06.226-.086.472C4.003 9.514 4 10.23 4 11.4v9.2c0 1.17.003 1.886.06 2.414.027.246.06.39.086.472.023.072.04.095.045.101.061.085.136.16.221.222.007.005.03.022.102.045.083.026.226.06.472.086.528.057 1.245.06 2.414.06h16.549c.79-.002 1.59-.003 2.353.245ZM30 11.4c0-2.25 0-3.375-.573-4.163a3.003 3.003 0 0 0-.664-.664C27.975 6 26.85 6 24.6 6H7.4c-2.25 0-3.375 0-4.163.573a3 3 0 0 0-.664.664C2 8.025 2 9.15 2 11.4v9.2c0 2.25 0 3.375.573 4.163.185.255.409.479.664.664C4.025 26 5.15 26 7.4 26h16.363c.98 0 1.47 0 1.921.147.15.048.295.109.435.18.424.216.77.562 1.463 1.255L29.5 29.5c.184.184.5.054.5-.207V11.4ZM23 14H9v-2h14v2ZM9 20h10v-2H9v2Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$t = [
  _hoisted_2$u
];
function render$u(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$u, _hoisted_3$t);
}
const ChatIcon = { render: render$u };
const _hoisted_1$t = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$t = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "m26.186 14.794-2.034.005-.014-6.148-6.88 6.88-1.442-1.43 6.88-6.88-6.176.015-.005-2.025 9.65-.022.021 9.605Zm-21.063 1.81 2.034-.005.014 6.148 6.88-6.88 1.442 1.428-6.88 6.88 6.176-.014.005 2.025-9.65.023-.021-9.606Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$s = [
  _hoisted_2$t
];
function render$t(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$t, _hoisted_3$s);
}
const ExpandIcon = { render: render$t };
const _hoisted_1$s = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$s = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.9 6.1h2v6.1l6.9-6.9 1.4 1.4-6.9 6.9h6.2v2h-9.6V6.1zm-.7 19.8h-2v-6.1l-6.9 6.9-1.4-1.4 6.9-6.9H5.6v-2h9.6v9.5z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$r = [
  _hoisted_2$s
];
function render$s(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$s, _hoisted_3$r);
}
const ReduceIcon = { render: render$s };
const _hoisted_1$r = {
  width: "33",
  height: "32",
  viewBox: "0 0 33 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$r = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M8.778 29.86c-.315 0-.63-.106-.91-.316a1.545 1.545 0 0 1-.56-1.75l2.416-7.425c.105-.315 0-.7-.28-.875L3.14 14.906a1.545 1.545 0 0 1-.56-1.75 1.533 1.533 0 0 1 1.47-1.086h7.81c.35 0 .665-.21.77-.56l2.417-7.424A1.533 1.533 0 0 1 16.517 3c.666 0 1.261.42 1.471 1.086l2.382 7.458c.105.316.42.56.77.56h7.81c.7 0 1.26.421 1.47 1.086.21.666 0 1.331-.56 1.751l-6.304 4.588c-.28.21-.385.56-.28.875l2.416 7.424c.21.666 0 1.331-.56 1.751-.56.42-1.26.42-1.82 0l-6.304-4.587a.788.788 0 0 0-.946 0L9.76 29.579c-.35.175-.665.28-.98.28Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$q = [
  _hoisted_2$r
];
function render$r(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$r, _hoisted_3$q);
}
const FavouriteFilledIcon = { render: render$r };
const _hoisted_1$q = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$q = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M8.287 28.86c.084-.002.218-.03.454-.141l6.228-4.532a1.788 1.788 0 0 1 2.132 0L23.4 28.77l.005.004.006.004c.205.154.416.154.621 0a.547.547 0 0 0 .208-.646l-2.412-7.412-.002-.005a1.78 1.78 0 0 1 .63-1.987l.006-.005.006-.004 6.296-4.582a.547.547 0 0 0 .203-.646c-.082-.258-.263-.387-.518-.387H20.64a1.832 1.832 0 0 1-1.719-1.244l-.004-.012-2.381-7.46-.001-.002A.534.534 0 0 0 16.017 4a.534.534 0 0 0-.517.387l-.002.008-2.414 7.415c-.246.8-.974 1.26-1.724 1.26H3.55a.534.534 0 0 0-.516.386L8.287 28.86Zm0 0h-.009a.515.515 0 0 1-.31-.116.547.547 0 0 1-.208-.646l2.412-7.412.002-.005c.218-.66.044-1.544-.664-2.012l-6.274-4.566a.547.547 0 0 1-.203-.646l5.254 15.402Z",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1);
const _hoisted_3$p = [
  _hoisted_2$q
];
function render$q(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$q, _hoisted_3$p);
}
const FavouriteOutlinedIcon = { render: render$q };
const _hoisted_1$p = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$p = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M26.506 15.192 15.9 4.586 5.293 15.192l1.414 1.415L8 15.314V25h16v-9.485l1.092 1.092 1.414-1.415ZM22 13.515l-6.1-6.1-5.9 5.899V23h12v-9.485Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$o = [
  _hoisted_2$p
];
function render$p(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$p, _hoisted_3$o);
}
const HomeIcon = { render: render$p };
const _hoisted_1$o = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$o = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M28 16c0 6.627-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4s12 5.373 12 12Zm2 0c0 7.732-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2s14 6.268 14 14ZM9 15v2h14v-2H9Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$n = [
  _hoisted_2$o
];
function render$o(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$o, _hoisted_3$n);
}
const MinusCircleIcon = { render: render$o };
const _hoisted_1$n = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$n = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9 6h14v20H9V6ZM7 28V4h18v24H7ZM21 8H11v2h10V8Zm0 4H11v2h10v-2Zm-10 4h5v2h-5v-2Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$m = [
  _hoisted_2$n
];
function render$n(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$n, _hoisted_3$m);
}
const NewsIcon = { render: render$n };
const _hoisted_1$m = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$m = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12Zm0 2c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14Zm1-15h6v2h-6v6h-2v-6H9v-2h6V9h2v6Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$l = [
  _hoisted_2$m
];
function render$m(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$m, _hoisted_3$l);
}
const PlusCircleIcon = { render: render$m };
const _hoisted_1$l = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$l = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M23.653 5.567a.5.5 0 0 1 .5 0l5.215 3.014a.5.5 0 0 1 .25.433v5.74l4.564 2.635 4.914-2.898a.5.5 0 0 1 .505-.002l5.44 3.15a.5.5 0 0 1 .25.432v12.057a.5.5 0 0 1-.25.433L24.153 42.633a.5.5 0 0 1-.5 0L2.75 30.561a.5.5 0 0 1-.25-.433V18.072a.5.5 0 0 1 .25-.433L23.653 5.567Zm9.54 12.405-4.075-2.352L9.23 27.114l8.945 5.163v-5.163a.5.5 0 0 1 .246-.43l14.773-8.712ZM8.73 26.248l19.888-11.494V9.88L8.73 21.375v4.873Zm-.5-5.74L28.117 9.015l-4.215-2.437L4.001 18.071l4.228 2.438Zm-4.73-1.57 4.23 2.437v5.74a.5.5 0 0 0 .25.432l10.444 6.029a.5.5 0 0 0 .75-.434V27.98l4.23 2.438v10.917L3.5 29.84V18.937Zm20.903 22.396V30.417l19.888-11.48V29.84L24.403 41.334ZM43.792 18.07 23.903 29.55l-4.237-2.442 19.687-11.608 4.439 2.57Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$k = [
  _hoisted_2$l
];
function render$l(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$l, _hoisted_3$k);
}
const ExtrudedProfileIcon = { render: render$l };
const _hoisted_1$k = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$k = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17.736 5.023c-.767-1.343-2.705-1.343-3.473 0l-3.131 5.48a1 1 0 0 0 1.736.993L16 6.016l2.612 4.57-2.552 1.424 5.964 2.261 1.21-6.263-2.875 1.604-2.623-4.589Zm9.308 15.926c.78 1.336-.189 3.014-1.736 3.007l-5.285-.023-.05 3.292-4.818-4.18 4.94-4.034-.043 2.922 5.265.023-3.18-5.452a1 1 0 0 1 1.727-1.008l3.18 5.453Zm-20.79 3.337c-1.547.007-2.516-1.67-1.736-3.007l2.663-4.566-2.827-1.688 6.029-2.084 1.024 6.296-2.509-1.498-2.653 4.547 6.313-.028a1 1 0 0 1 .009 2l-6.313.028Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$j = [
  _hoisted_2$k
];
function render$k(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$k, _hoisted_3$j);
}
const RecycleIcon = { render: render$k };
const _hoisted_1$j = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$j = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M31.654 4.503c1.159-.044 2.4.37 3.63 1.077 2.44 1.402 4.577 3.937 6.102 6.868 1.527 2.934 2.486 6.316 2.486 9.48 0 1.44-.2 2.735-.577 3.839 0 .002 0 .005-.002.007-.018.065-.038.13-.061.193-.11.304-.234.603-.37.897a5.093 5.093 0 0 1-2.02 2.124l-20.081 11.64c-2.15.914-4.62.153-6.798-1.518-2.2-1.685-4.241-4.386-5.647-7.69-1.407-3.305-1.937-6.649-1.627-9.402.303-2.691 1.44-4.973 3.533-5.913a.357.357 0 0 1 .012-.008l.009-.005L28.308 5.724c.419-.276.849-.506 1.123-.653l.002-.002a5.03 5.03 0 0 0 .16-.09l.006-.003c.181-.105.382-.222.708-.309.313-.084.725-.137 1.346-.163h.002l-.001-.001Zm8.648 23.303c.339-.248.652-.563.933-.959l.002-.003c.774-1.073 1.266-2.728 1.266-4.896 0-2.898-.887-6.084-2.333-8.843l-.001-.001c-1.449-2.783-3.431-5.087-5.558-6.307l-.004-.003c-1.067-.625-2.069-.903-2.914-.903-.542 0-1.036.105-1.487.309l-16.681 9.616c1.214.264 2.436.89 3.583 1.768 2.198 1.686 4.24 4.387 5.647 7.69 1.406 3.305 1.936 6.65 1.626 9.402-.093.892-.3 1.769-.618 2.608l16.54-9.478h-.001ZM21.08 38.822c1.013-.84 1.7-2.326 1.922-4.301.279-2.474-.194-5.577-1.524-8.702s-3.238-5.618-5.214-7.133c-1.962-1.503-3.862-1.959-5.337-1.371l-.021.012-.033.013a.745.745 0 0 1-.05.018c-1.469.643-2.474 2.335-2.753 4.816-.279 2.473.194 5.577 1.524 8.702s3.238 5.617 5.214 7.132c1.995 1.529 3.925 1.974 5.41 1.342.182-.078.355-.17.52-.277.05-.062.009-.005 0 0l.342-.25v-.001Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$i = [
  _hoisted_2$j
];
function render$j(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$j, _hoisted_3$i);
}
const RodIcon = { render: render$j };
const _hoisted_1$i = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$i = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M23 6H9v20h14V6ZM7 4v24h18V4H7Zm4 18h10v2H11v-2Zm7.36-4.3c.427-.494.64-1.082.64-1.765 0-.223-.028-.433-.084-.63a2.48 2.48 0 0 0-.202-.511 1.721 1.721 0 0 0-.341-.426 4.129 4.129 0 0 0-.399-.335 3.848 3.848 0 0 0-.485-.284 8.559 8.559 0 0 0-1.01-.445 9.806 9.806 0 0 1-.84-.365 2.236 2.236 0 0 1-.36-.208 2.84 2.84 0 0 1-.253-.221.752.752 0 0 1-.19-.278.915.915 0 0 1-.055-.321c0-.304.13-.552.386-.744.258-.192.59-.287.997-.287.18 0 .363.025.55.076a2.788 2.788 0 0 1 .855.389c.118.078.202.137.251.177.05.04.08.067.093.08a.2.2 0 0 0 .174.048c.064-.005.114-.04.148-.108l.52-.977c.052-.09.041-.174-.031-.255a2.297 2.297 0 0 0-.097-.094 3.429 3.429 0 0 0-.25-.194 3.074 3.074 0 0 0-.41-.25 4.02 4.02 0 0 0-1.27-.38V8.215a.214.214 0 0 0-.057-.154.196.196 0 0 0-.148-.06h-.868a.194.194 0 0 0-.145.064.21.21 0 0 0-.06.15V9.42c-.674.134-1.22.433-1.64.897a2.34 2.34 0 0 0-.63 1.62c0 .184.017.358.054.523.036.165.081.313.135.445.053.132.13.261.228.389.099.127.192.236.28.328.088.091.202.186.344.284.141.098.263.178.363.238.101.06.235.13.402.208.167.078.3.137.396.177l.395.167c.232.094.403.167.514.218.112.051.253.123.425.214.171.092.297.176.376.252.08.075.151.17.216.28a.7.7 0 0 1 .096.356c0 .352-.132.625-.395.817-.264.192-.57.288-.917.288-.158 0-.317-.018-.476-.054-.557-.116-1.078-.395-1.562-.837l-.013-.014a.156.156 0 0 0-.155-.06c-.068.01-.117.036-.147.08l-.663.905c-.064.089-.06.18.013.274.021.027.059.067.113.12.053.054.153.138.299.252.145.114.304.22.475.321.172.1.39.2.653.298.264.099.537.168.82.208v1.172c0 .058.02.108.061.15.04.043.09.064.145.064h.868c.06 0 .11-.02.148-.06a.213.213 0 0 0 .058-.154v-1.172c.681-.116 1.236-.42 1.662-.914Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$h = [
  _hoisted_2$i
];
function render$i(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$i, _hoisted_3$h);
}
const SalesQuoteIcon = { render: render$i };
const _hoisted_1$h = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$h = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10 25V7h13v18H10ZM8 6a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V6Zm13 4h-9v2h9v-2Zm-5 5h5v2h-5v-2Zm5 5h-5v2h5v-2Zm-9-5h2v2h-2v-2Zm2 5h-2v2h2v-2Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$g = [
  _hoisted_2$h
];
function render$h(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$h, _hoisted_3$g);
}
const SalesQuote2Icon = { render: render$h };
const _hoisted_1$g = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$g = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M21.35 18H25c1.65 0 3 1.35 3 3v4c0 1.65-1.35 3-3 3H7c-1.65 0-3-1.35-3-3V7c0-1.65 1.35-3 3-3h4c1.65 0 3 1.35 3 3v3.65l2.8-2.75a2.987 2.987 0 0 1 4.2 0l3.1 3.15a2.987 2.987 0 0 1 0 4.2L21.35 18ZM19.6 9.3c-.4-.35-1-.35-1.4 0L14 13.5v9l8.75-8.65c.35-.4.35-1 0-1.4L19.6 9.3ZM11 26c.45 0 .9-.35.95-.85l.05-.45V7c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h4Zm14 0c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-5.65l-5.4 5.4-.15.6H25Zm-14-3H7v2h4v-2Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$f = [
  _hoisted_2$g
];
function render$g(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$g, _hoisted_3$f);
}
const SampleIcon = { render: render$g };
const _hoisted_1$f = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$f = /* @__PURE__ */ vue.createElementVNode("mask", {
  id: "path-1-inside-1_2463_3524",
  fill: "#fff"
}, [
  /* @__PURE__ */ vue.createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.156 6.694a2.652 2.652 0 0 1 2.651-2.652h1.872a2.651 2.651 0 0 1 2.651 2.652v1.741c.41.194.8.421 1.17.676l1.509-.87a2.652 2.652 0 0 1 3.622.97l.936 1.62a2.651 2.651 0 0 1-.971 3.623l-1.51.871a8.47 8.47 0 0 1 0 1.35l1.51.871a2.652 2.652 0 0 1 .97 3.623l-.935 1.62a2.651 2.651 0 0 1-3.622.97l-1.51-.87c-.369.255-.76.482-1.169.676v1.741a2.651 2.651 0 0 1-2.651 2.652h-1.872a2.651 2.651 0 0 1-2.651-2.652v-1.741c-.41-.195-.8-.421-1.17-.677l-1.509.872a2.652 2.652 0 0 1-3.622-.97l-.936-1.622a2.652 2.652 0 0 1 .97-3.622l1.51-.871a8.483 8.483 0 0 1 0-1.35l-1.509-.871a2.651 2.651 0 0 1-.97-3.622l.935-1.621a2.652 2.652 0 0 1 3.622-.97l1.51.87c.369-.255.76-.482 1.169-.676V6.694Z"
  })
], -1);
const _hoisted_3$e = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M19.33 8.435h-2V9.7l1.142.543.858-1.807Zm1.17.676-1.138 1.645 1.04.72 1.098-.633-1-1.732Zm1.509-.87-1-1.733 1 1.732Zm3.622.97 1.732-1-1.732 1Zm.936 1.62-1.733 1 1.733-1Zm-.971 3.623 1 1.732-1-1.732Zm-1.51.871-1-1.732-1.094.632.1 1.26 1.995-.16Zm0 1.35-1.993-.16-.1 1.26 1.094.632 1-1.732Zm1.51.871-1 1.733 1-1.733Zm.97 3.623 1.733 1-1.732-1Zm-.935 1.62-1.732-1 1.732 1Zm-3.622.97 1-1.731-1 1.732Zm-1.51-.87 1-1.733-1.096-.633-1.041.72L20.5 22.89Zm-1.169.676-.858-1.807-1.142.543v1.264h2Zm-7.174 0h2V22.3l-1.142-.543-.858 1.807Zm-1.17-.677 1.138-1.644-1.041-.72-1.097.632 1 1.732Zm-1.509.872 1 1.732-1-1.732Zm-3.622-.97 1.732-1-1.732 1Zm-.936-1.622 1.732-1-1.732 1Zm.97-3.622-1-1.732 1 1.732Zm1.51-.871 1 1.732 1.095-.632-.101-1.26-1.994.16Zm0-1.35 1.994.16.1-1.26-1.094-.632-1 1.732Zm-1.509-.871 1-1.732-1 1.732Zm-.97-3.622 1.732 1-1.733-1Zm.935-1.621-1.732-1 1.732 1Zm3.622-.97 1-1.733-1 1.732Zm1.51.87-1 1.732 1.096.634 1.041-.72-1.138-1.646Zm1.169-.676.858 1.807 1.142-.543V8.435h-2Zm2.651-6.393a4.651 4.651 0 0 0-4.651 4.652h4c0-.36.291-.652.651-.652v-4Zm1.872 0h-1.872v4h1.872v-4Zm4.651 4.652a4.651 4.651 0 0 0-4.651-4.652v4c.36 0 .651.292.651.652h4Zm0 1.741V6.694h-4v1.741h4Zm-2.858 1.807c.311.147.608.32.89.514l2.275-3.29a10.362 10.362 0 0 0-1.449-.837l-1.716 3.613Zm2.537-3.734-1.51.871 2 3.465 1.51-.872-2-3.464Zm6.354 1.703a4.652 4.652 0 0 0-6.354-1.703l2 3.464a.652.652 0 0 1 .89.239l3.464-2Zm.936 1.62-.936-1.62-3.464 2 .935 1.62 3.465-2Zm-1.703 6.355a4.652 4.652 0 0 0 1.703-6.355l-3.465 2c.18.312.074.71-.238.89l2 3.465Zm-1.51.871 1.51-.871-2-3.464-1.51.871 2 3.464Zm-2.993-1.573c.013.17.02.342.02.516h4c0-.28-.01-.559-.033-.834l-3.987.318Zm.02.516c0 .174-.007.346-.02.516l3.987.318c.022-.276.033-.554.033-.834h-4Zm4.483-.186-1.51-.871-2 3.464 1.51.872 2-3.465ZM28.3 22.17a4.652 4.652 0 0 0-1.703-6.355l-2 3.465c.312.18.419.578.239.89l3.464 2Zm-.936 1.62.936-1.62-3.464-2-.936 1.62 3.464 2Zm-6.354 1.703a4.652 4.652 0 0 0 6.354-1.703l-3.464-2a.652.652 0 0 1-.89.239l-2 3.464Zm-1.51-.872 1.51.872 2-3.464-1.51-.872-2 3.465Zm-.137-3.376a6.36 6.36 0 0 1-.89.514l1.716 3.613a10.36 10.36 0 0 0 1.45-.838l-2.276-3.29Zm1.968 4.062v-1.741h-4v1.741h4Zm-4.651 4.652a4.651 4.651 0 0 0 4.651-4.652h-4c0 .36-.291.652-.651.652v4Zm-1.872 0h1.872v-4h-1.872v4Zm-4.651-4.652a4.652 4.652 0 0 0 4.651 4.652v-4a.652.652 0 0 1-.651-.652h-4Zm0-1.741v1.741h4v-1.741h-4Zm2.858-1.807a6.363 6.363 0 0 1-.89-.514l-2.276 3.29c.458.316.942.596 1.45.837l1.716-3.613Zm-2.537 3.734 1.51-.872-2-3.464-1.51.872 2 3.464Zm-6.354-1.703a4.651 4.651 0 0 0 6.354 1.703l-2-3.464a.652.652 0 0 1-.89-.239l-3.464 2Zm-.936-1.62.936 1.62 3.464-2-.936-1.62-3.464 2Zm1.703-6.355a4.652 4.652 0 0 0-1.703 6.354l3.464-2a.652.652 0 0 1 .239-.89l-2-3.464Zm1.51-.871-1.51.871 2 3.464 1.51-.871-2-3.464Zm2.993 1.573a6.488 6.488 0 0 1-.02-.516h-4c0 .28.01.558.033.834l3.987-.318ZM9.373 16c0-.174.006-.346.02-.516l-3.987-.318c-.022.275-.033.554-.033.834h4Zm-4.483.186 1.51.871 2-3.464-1.51-.871-2 3.464ZM3.187 9.832a4.652 4.652 0 0 0 1.703 6.354l2-3.464a.652.652 0 0 1-.238-.89l-3.465-2Zm.936-1.621-.936 1.62 3.465 2 .935-1.62-3.464-2Zm6.354-1.703a4.652 4.652 0 0 0-6.354 1.703l3.464 2a.652.652 0 0 1 .89-.239l2-3.464Zm1.51.871-1.51-.87-2 3.463 1.51.872 2-3.465Zm.137 3.377c.281-.194.579-.367.89-.514l-1.717-3.613c-.507.24-.991.521-1.449.838l2.276 3.29Zm-1.968-4.062v1.741h4V6.694h-4Z",
  fill: "currentColor",
  mask: "url(#path-1-inside-1_2463_3524)"
}, null, -1);
const _hoisted_4$8 = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_5$5 = [
  _hoisted_2$f,
  _hoisted_3$e,
  _hoisted_4$8
];
function render$f(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$f, _hoisted_5$5);
}
const SettingsIcon = { render: render$f };
const _hoisted_1$e = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$e = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17.36 3.387v-.001l.003.002v-.001l.126.074 20.867 12.058h-.002l-.017.03h.001l.018-.03c.122.07.22.176.282.303h.001a.498.498 0 0 1 .045.15c.012.035.02.072.024.11l-.021.002v.001l.02-.001a.381.381 0 0 1 .002.049v24.225a.709.709 0 0 1-.354.613l-7.001 4.056a.716.716 0 0 1-.714.002v.001L9.646 32.897l.217-.375-.001-.001-.217.375a.708.708 0 0 1-.354-.613V8.038h.5v-.001h-.5a.7.7 0 0 1 .072-.31v-.001a.709.709 0 0 1 .283-.303l.25.433-.25-.433 7.005-4.037a.71.71 0 0 1 .709 0h-.001l.001.001Zm-7.465 4.47v-.001.001Zm-.083.089-.088-.043.088.043Zm21.078 36.65-.25.433h.001l.25-.433h-.001ZM16.756 4.675l-.001-.001.001.001Zm.249.143-5.587 3.22 19.579 11.314 5.586-3.22L17.005 4.818Zm-6.296 27.055 19.577 11.314V20.58L10.709 9.264v22.609ZM31.704 20.58v22.605l5.587-3.235V17.36l-5.587 3.22ZM9.645 32.896l.001.001-.001-.001Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$d = [
  _hoisted_2$e
];
function render$e(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$e, _hoisted_3$d);
}
const SheetIcon = { render: render$e };
const _hoisted_1$d = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$d = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17.36 3.387v-.001l.003.002v-.001l.126.074 20.867 12.058h-.002l-.017.03h.001l.018-.03c.122.07.22.176.282.303h.001a.498.498 0 0 1 .045.15c.012.035.02.072.024.11l-.021.002v.001l.02-.001a.381.381 0 0 1 .002.049v24.225a.709.709 0 0 1-.354.613l-7.001 4.056a.716.716 0 0 1-.714.002v.001L9.646 32.897l.217-.375-.001-.001-.217.375a.708.708 0 0 1-.354-.613V8.038h.5v-.001h-.5a.7.7 0 0 1 .072-.31v-.001a.709.709 0 0 1 .283-.303l.25.433-.25-.433 7.005-4.037a.71.71 0 0 1 .709 0h-.001l.001.001Zm-7.465 4.47v-.001.001Zm-.083.089-.088-.043.088.043Zm21.078 36.65-.25.433h.001l.25-.433h-.001ZM16.756 4.675l-.001-.001.001.001Zm.249.143-5.587 3.22 19.579 11.314 5.586-3.22L17.005 4.818Zm-6.296 27.055 19.577 11.314V20.58L10.709 9.264v22.609ZM31.704 20.58v22.605l5.587-3.235V17.36l-5.587 3.22ZM9.645 32.896l.001.001-.001-.001Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$c = [
  _hoisted_2$d
];
function render$d(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$d, _hoisted_3$c);
}
const PlateIcon = { render: render$d };
const _hoisted_1$c = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$c = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M40.7 27.306c.36-.267.675-.591.93-.959l.004-.003c.774-1.073 1.265-2.728 1.265-4.896 0-2.898-.887-6.084-2.333-8.843v-.001c-1.45-2.783-3.431-5.087-5.558-6.307l-.004-.003c-1.067-.625-2.07-.903-2.914-.903-.542 0-1.036.105-1.487.309l-16.681 9.616c1.214.264 2.435.89 3.582 1.768 2.2 1.686 4.24 4.387 5.647 7.69 1.406 3.305 1.937 6.65 1.627 9.402-.093.892-.3 1.769-.618 2.608l16.54-9.478Zm-30.082-11.7.013-.009.008-.005L28.704 5.223c.42-.276.85-.506 1.123-.653l.003-.002.16-.09.005-.003c.182-.105.383-.222.708-.309.314-.084.726-.137 1.346-.163h.002c1.158-.044 2.4.37 3.63 1.077 2.44 1.402 4.577 3.937 6.102 6.868 1.526 2.934 2.486 6.316 2.486 9.48 0 1.44-.2 2.735-.577 3.839l-.002.007c-.018.065-.039.13-.061.193a7.97 7.97 0 0 1-.122.322c-.08.2-.186.46-.248.575a5.092 5.092 0 0 1-2.02 2.124l-20.081 11.64c-2.15.914-4.62.153-6.8-1.518-2.198-1.685-4.24-4.386-5.646-7.69-1.406-3.305-1.937-6.649-1.626-9.402.303-2.691 1.439-4.973 3.532-5.913v.001Zm10.858 22.716c1.013-.84 1.7-2.326 1.922-4.301.279-2.474-.195-5.577-1.524-8.702-1.33-3.125-3.238-5.618-5.214-7.133-1.963-1.503-3.862-1.959-5.337-1.371l-.021.012-.034.013a.725.725 0 0 1-.05.018c-1.468.643-2.473 2.335-2.752 4.816-.28 2.473.194 5.577 1.524 8.702s3.238 5.617 5.214 7.132c1.995 1.529 3.924 1.974 5.41 1.342a3.55 3.55 0 0 0 .52-.277l.342-.25v-.001ZM12.79 20.467c1.317-.56 2.785.03 3.997 1.042 1.244 1.038 2.407 2.656 3.234 4.598.826 1.941 1.186 3.901 1.07 5.518-.111 1.575-.702 3.042-2.02 3.603-1.318.56-2.785-.03-3.997-1.042-1.245-1.038-2.408-2.657-3.234-4.598-.826-1.941-1.186-3.902-1.071-5.518.11-1.575.703-3.042 2.02-3.603Zm3.107 2.108c-1.074-.896-1.975-1.08-2.564-.83-.59.25-1.08 1.027-1.18 2.423-.095 1.355.207 3.094.965 4.876.758 1.782 1.802 3.206 2.845 4.076 1.075.896 1.975 1.08 2.565.83.588-.25 1.08-1.028 1.179-2.423.096-1.355-.206-3.095-.964-4.876-.76-1.782-1.803-3.206-2.846-4.076Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$b = [
  _hoisted_2$c
];
function render$c(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$c, _hoisted_3$b);
}
const TubeIcon = { render: render$c };
const _hoisted_1$b = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$b = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M40.7 27.306c.36-.267.675-.591.93-.959l.004-.003c.774-1.073 1.265-2.728 1.265-4.896 0-2.898-.887-6.084-2.333-8.843v-.001c-1.45-2.783-3.431-5.087-5.558-6.307l-.004-.003c-1.067-.625-2.07-.903-2.914-.903-.542 0-1.036.105-1.487.309l-16.681 9.616c1.214.264 2.435.89 3.582 1.768 2.2 1.686 4.24 4.387 5.647 7.69 1.406 3.305 1.937 6.65 1.627 9.402-.093.892-.3 1.769-.618 2.608l16.54-9.478Zm-30.082-11.7.013-.009.008-.005L28.704 5.223c.42-.276.85-.506 1.123-.653l.003-.002.16-.09.005-.003c.182-.105.383-.222.708-.309.314-.084.726-.137 1.346-.163h.002c1.158-.044 2.4.37 3.63 1.077 2.44 1.402 4.577 3.937 6.102 6.868 1.526 2.934 2.486 6.316 2.486 9.48 0 1.44-.2 2.735-.577 3.839l-.002.007c-.018.065-.039.13-.061.193a7.97 7.97 0 0 1-.122.322c-.08.2-.186.46-.248.575a5.092 5.092 0 0 1-2.02 2.124l-20.081 11.64c-2.15.914-4.62.153-6.8-1.518-2.198-1.685-4.24-4.386-5.646-7.69-1.406-3.305-1.937-6.649-1.626-9.402.303-2.691 1.439-4.973 3.532-5.913v.001Zm10.858 22.716c1.013-.84 1.7-2.326 1.922-4.301.279-2.474-.195-5.577-1.524-8.702-1.33-3.125-3.238-5.618-5.214-7.133-1.963-1.503-3.862-1.959-5.337-1.371l-.021.012-.034.013a.725.725 0 0 1-.05.018c-1.468.643-2.473 2.335-2.752 4.816-.28 2.473.194 5.577 1.524 8.702s3.238 5.617 5.214 7.132c1.995 1.529 3.924 1.974 5.41 1.342a3.55 3.55 0 0 0 .52-.277l.342-.25v-.001ZM12.79 20.467c1.317-.56 2.785.03 3.997 1.042 1.244 1.038 2.407 2.656 3.234 4.598.826 1.941 1.186 3.901 1.07 5.518-.111 1.575-.702 3.042-2.02 3.603-1.318.56-2.785-.03-3.997-1.042-1.245-1.038-2.408-2.657-3.234-4.598-.826-1.941-1.186-3.902-1.071-5.518.11-1.575.703-3.042 2.02-3.603Zm3.107 2.108c-1.074-.896-1.975-1.08-2.564-.83-.59.25-1.08 1.027-1.18 2.423-.095 1.355.207 3.094.965 4.876.758 1.782 1.802 3.206 2.845 4.076 1.075.896 1.975 1.08 2.565.83.588-.25 1.08-1.028 1.179-2.423.096-1.355-.206-3.095-.964-4.876-.76-1.782-1.803-3.206-2.846-4.076Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$a = [
  _hoisted_2$b
];
function render$b(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$b, _hoisted_3$a);
}
const TubularTubeIcon = { render: render$b };
const _hoisted_1$a = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$a = /* @__PURE__ */ vue.createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M20.145 23.043a8.773 8.773 0 0 1-8.361-1.395L6.43 27 5 25.57l5.353-5.354a8.773 8.773 0 0 1 4.933-13.998 8.777 8.777 0 0 1 8.146 2.35 8.77 8.77 0 0 1-3.287 14.475Zm1.85-13.038a6.741 6.741 0 0 0-9.54 0 6.741 6.741 0 0 0 0 9.541 6.741 6.741 0 0 0 9.54 0 6.74 6.74 0 0 0 0-9.54ZM18 19h-2v-3h-3v-2h3v-3h2v3h3v2h-3v3Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$9 = [
  _hoisted_2$a
];
function render$a(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$a, _hoisted_3$9);
}
const ZoomIcon = { render: render$a };
const _hoisted_1$9 = {
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200"
};
const _hoisted_2$9 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M179.18 162.71c12.7-9.21 20.82-22.82 20.82-37.95 0-27.72-26.97-50.19-60.24-50.19s-60.24 22.48-60.24 50.19 26.97 50.2 60.24 50.2a71.3 71.3 0 0 0 19.67-2.75l1.77-.27c1.16 0 2.21.36 3.2.93l13.19 7.62 1.16.38c1.11 0 2.01-.9 2.01-2.01l-.32-1.47-2.72-10.13-.21-1.28c0-1.35.67-2.54 1.68-3.27ZM72.29 19.14C32.37 19.14 0 46.11 0 79.38c0 18.15 9.73 34.5 24.98 45.54 1.23.87 2.03 2.3 2.03 3.92l-.25 1.53-3.26 12.15-.39 1.76a2.42 2.42 0 0 0 2.41 2.42l1.4-.45 15.83-9.14c1.18-.68 2.44-1.11 3.83-1.11l2.13.32a85.651 85.651 0 0 0 23.6 3.31l3.97-.1c-1.57-4.7-2.43-9.65-2.43-14.76 0-30.34 29.52-54.94 65.92-54.94l3.93.1c-5.44-28.78-35.33-50.78-71.39-50.78Zm47.38 97.59a8.03 8.03 0 1 1 0-16.06c4.44 0 8.03 3.59 8.03 8.03s-3.59 8.03-8.03 8.03Zm40.17 0c-4.44 0-8.03-3.6-8.03-8.03s3.59-8.03 8.03-8.03 8.02 3.59 8.02 8.03-3.59 8.03-8.02 8.03ZM48.19 69.74c-5.32 0-9.63-4.32-9.63-9.63s4.31-9.64 9.63-9.64 9.64 4.32 9.64 9.64-4.32 9.63-9.64 9.63Zm48.19 0c-5.32 0-9.63-4.32-9.63-9.63s4.31-9.64 9.63-9.64 9.64 4.32 9.64 9.64-4.32 9.63-9.64 9.63Z",
  style: { "fill": "currentcolor", "fill-rule": "evenodd" }
}, null, -1);
const _hoisted_3$8 = [
  _hoisted_2$9
];
function render$9(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$9, _hoisted_3$8);
}
const WechatIcon = { render: render$9 };
const _hoisted_1$8 = {
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200"
};
const _hoisted_2$8 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M89.79 71.75C78.59 64.74 66.95 58.5 55.63 51.7c-6.94-4.17-10.69-10.78-12.13-18.66-1.91-10.43 1.71-19 9.23-26.11C57.18 2.73 62.51.65 68.7.11c8.72-.76 16.01 2.47 23.21 6.75 11.54 6.85 23.27 13.39 34.85 20.16 7.91 4.63 16.14 8.74 23.69 13.96 9.98 6.9 15.16 16.37 15.78 28.59.46 9.22-1.65 17.51-7.14 24.85-3.15 4.22-7.23 7.55-11.73 10.32-5.21-3.08-10.4-6.18-15.62-9.22-8.66-5.04-17.26-10.18-26.04-15.01-5.3-2.92-10.3-6.41-15.91-8.77Z",
  style: { "fill": "currentcolor" }
}, null, -1);
const _hoisted_3$7 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M89.79 71.75c5.61 2.36 10.61 5.85 15.91 8.77 8.77 4.83 17.38 9.97 26.04 15.01 5.23 3.04 10.42 6.14 15.62 9.22-14.67 8.35-29.36 16.67-44 25.07-7.35 4.22-14.41 9.02-22.23 12.31-8.76 3.68-17.17 2.23-25.04-2.96-8.57-5.65-13.07-13.88-13.08-23.76-.02-10.92 5.35-19.41 15.04-25.01 10.62-6.14 21.16-12.43 31.74-18.66ZM64.23 199.88c-4.16.19-7.63-1.29-10.69-3.94-3.09-2.68-5.1-6-5.53-10.02-.37-3.49-.39-7.05.33-10.53.48-2.34 1.67-4.35 3.16-6.21 1.94-2.42 4.39-4.13 7.29-5.15 2.06-.72 4.23-.93 6.41-.79 3.25.2 6.24 1.22 8.79 3.23 3.39 2.66 5.51 6.06 6.19 10.4.47 2.96.33 5.91.09 8.82-.28 3.44-1.8 6.45-4.25 9-2.15 2.23-4.65 3.83-7.62 4.73-1.39.42-2.8.54-4.18.47Zm-8.27-18.09c.04 1.14-.07 2.56.3 3.99.89 3.37 4.69 6.72 8.99 6 2.19-.37 3.98-1.44 5.34-3.16.99-1.26 1.48-2.71 1.62-4.37.2-2.3.28-4.59-.16-6.82-.7-3.55-4.58-6.56-8.51-6.13-3.08.33-5.25 1.9-6.74 4.54-1 1.79-.84 3.73-.84 5.95ZM82.64 175.47c0-2.95-.04-5.91.01-8.86.03-2.05 2.81-3.99 4.79-3.4.55.17 1.1.4 1.6.69.99.59 1.56 1.42 1.6 2.66.23 5.89.07 11.79.22 17.68.06 2.46 1.42 4.46 3.36 6.01 1.36 1.08 2.97 1.55 4.64 1.68 1.97.15 3.74-.6 5.28-1.77 2.26-1.71 3.18-4 3.31-6.86.25-5.55.03-11.1.14-16.64.04-2.25 2.64-4.08 4.9-3.45 1.9.53 3.14 2.05 3.16 4.03.05 5.46.13 10.93.04 16.39-.06 4.07-1.47 7.8-4.16 10.83-2.5 2.82-5.79 4.55-9.56 5.29-1.42.28-2.84.27-4.24.14-3.81-.35-7.21-1.77-9.96-4.46-2.26-2.21-3.8-4.88-4.58-7.97-.4-1.55-.53-3.11-.52-4.7v-7.3h-.02ZM187.42 176.22c0 2.94.07 5.88-.03 8.81-.06 1.86-.66 3.62-1.45 5.34-.84 1.82-1.96 3.38-3.36 4.8-1.95 1.97-4.26 3.39-6.9 4.12-4.13 1.14-8.23.99-12.09-1.08-4.54-2.43-7.44-6.19-8.73-11.16-.19-.72-.21-1.49-.21-2.23-.02-5.56.02-11.12-.04-16.68-.01-1.23.08-2.32.77-3.41 1.36-2.14 4.51-1.88 5.86-.64.99.91 1.41 1.98 1.42 3.32 0 4.83.15 9.66.05 14.49-.04 1.95.06 3.79 1 5.5 1.32 2.43 3.3 3.91 6.11 4.39 2.57.44 4.7-.44 6.57-1.94 1.98-1.59 2.97-3.81 2.98-6.37.03-5.46.01-10.93.03-16.39 0-1.78 1.11-3.34 2.83-3.77 2.46-.62 5.18.55 5.22 3.88.04 3 0 6 0 9h-.04ZM25.93 189.71c0-2.24-.01-4.48.01-6.73 0-.51-.16-.87-.53-1.23-3.89-3.85-7.75-7.74-11.66-11.57-1.27-1.24-1.68-3.85-.62-5.32 1.43-1.99 4.35-2.36 6.12-.61 3.33 3.3 6.65 6.6 9.95 9.92.5.51.78.58 1.33.03 3.24-3.29 6.52-6.54 9.8-9.8 1.24-1.24 2.77-1.59 4.38-1.04 1.44.49 2.33 1.52 2.53 3.15.16 1.35-.1 2.49-1.07 3.45-3.87 3.85-7.73 7.7-11.61 11.54-.37.37-.48.75-.48 1.25.02 4.17.01 8.34.01 12.51 0 2.08-.79 3.68-2.85 4.46-2.36.89-4.98-.64-5.16-3.01-.18-2.32-.04-4.67-.04-7.01h-.09ZM151.61 196.09c.13 1.8-1.11 2.9-2.77 3.67-1.2.56-2.95.08-4.11-1.07-4.36-4.33-8.7-8.67-13.06-12.99-2.34-2.32-2.34-6.2 0-8.51 4.13-4.06 8.21-8.18 12.33-12.25 1.26-1.25 2.62-2.06 4.61-1.69 2.68.49 3.92 3.79 2.27 6.23-.3.44-.67.83-1.05 1.2-3.4 3.4-6.8 6.81-10.23 10.19-.52.51-.45.75.01 1.24 3.51 3.7 7.17 7.23 10.79 10.82.84.83 1.22 1.77 1.22 3.16ZM127.99 181.55c0 4.68-.1 9.36.04 14.03.08 2.76-2.35 4.69-4.72 4.33-1.29-.2-2.19-.97-2.92-1.98-.38-.53-.46-1.11-.46-1.8.04-9.7.02-19.4.03-29.1 0-2.37 1.77-3.9 3.92-3.9 2.35 0 4.1 1.47 4.11 4.01.01 4.8 0 9.61 0 14.41Z",
  style: { "fill": "currentcolor" }
}, null, -1);
const _hoisted_4$7 = [
  _hoisted_2$8,
  _hoisted_3$7
];
function render$8(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$8, _hoisted_4$7);
}
const YoukuIcon = { render: render$8 };
const _hoisted_1$7 = {
  id: "Icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 128 128"
};
const _hoisted_2$7 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none" },
  d: "M0 0h128v128H0z"
}, null, -1);
const _hoisted_3$6 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M64.69 111.1c-1.67-1.68-.51-3.11-2.25-6.59-1.44-2.88-2.53-2.46-3.17-4.7-.8-2.77.69-3.96-.38-6.58-.82-1.99-1.84-1.68-2.27-3.29-.64-2.4 1.48-3.67 2.24-7.63.2-1.03.57-2.95 0-5.13-1.02-3.95-3.89-4.08-5-8.38-.57-2.21-.42-4.36-.42-4.36.15-2.19.73-2.54.52-3.68-.42-2.24-3.32-4.21-6.05-4.39-2.39-.15-2.77 1.19-6.98 2.65-2.29.79-5.28 1.83-8.69 1.16-2.32-.45-3.81-1.5-6-3.03-4.45-3.12-6.58-6.66-7.06-7.48-1.29-2.22-2.1-3.62-2.11-5.64-.01-1.94.73-2.53 1.83-6.59.92-3.38.46-3.13 1.13-5.01 1.41-3.93 3.99-6.49 4.69-7.16 2.33-2.22 3.16-1.8 4.35-3.65 1.67-2.59.7-4.4 2.06-5.24 1.77-1.08 3.82 1.75 7.54 1.18 1.85-.28 1.43-1 4.12-1.94 2.11-.74 4.61-.69 9.62-.6 2.09.04 2.74.12 3.28.64 1.3 1.25-.05 3.1 1.15 5.09 1.45 2.41 5.2 2.62 5.87 2.66 1.53.08 2.68-.26 2.97-.36 1.42-.46 1.89-1.06 2.82-1.57 1.73-.94 3.45-.67 6.8-.15 2.38.37 4.07.63 5.99 1.83.5.31 2.14 1.4 3.53 3.42 1.13 1.66 1.38 2.91 1.97 4.68 1.22 3.66 1.75 3.12 3.69 7.76 2.06 4.92 1.76 6.24 3.82 8.71 1.61 1.93 3.11 2.71 3.74 3 .63.29 1.98.83 4.66.92 5.05.16 7.57-1.54 8.13-.71.64.93-1.96 4.03-4.33 6.13-3.82 3.38-5.45 2.73-8.01 5.72-1.66 1.94-2.44 3.92-3.48 6.58-1.05 2.68-1.63 4.15-1.61 6.19.03 3.27 1.53 3.58 1.47 6.65-.01.49-.16 4.69-2.92 6.54-1.75 1.17-2.92.3-3.81 1.42-1.25 1.57.76 3.56-.12 7.29-.28 1.21-.73 2.01-1.61 3.57-.66 1.18-1.57 2.57-3.79 5.08-3.36 3.81-5.04 5.71-7.19 6.41-1.86.6-3.49.48-4.82.38-2.27-.17-4.44-.34-5.92-1.81ZM101.21 85.5c.7-1.09 1.8-3.77 3.23-3.95 2.73-.34 3.62 3.52 3.37 5.46-.21 1.6-.79 1.77-1.73 4.02-1.06 2.55-.57 2.97-1.69 5.65-.84 2.01-1.5 3.54-2.83 3.81-1.23.25-2.31-.73-2.45-.86-1.4-1.3-1.03-3.36-.97-3.69.23-1.3.8-1.23 1.18-2.58.54-1.92-.46-2.6-.07-4.5.1-.51.21-.64 1.95-3.35Z",
  style: { "stroke": "#ff000f", "stroke-miterlimit": "10", "stroke-width": "2px", "fill": "none" }
}, null, -1);
const _hoisted_4$6 = [
  _hoisted_2$7,
  _hoisted_3$6
];
function render$7(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$7, _hoisted_4$6);
}
const AfricaIcon = { render: render$7 };
const _hoisted_1$6 = {
  id: "Icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 128 128"
};
const _hoisted_2$6 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none" },
  d: "M0 0h128v128H0z"
}, null, -1);
const _hoisted_3$5 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M76.27 113c-1.84.09-3.07-1.28-3.23-1.46-.72-.83-.91-1.71-1.05-2.42-.07-.36-.2-1.16.4-4.81.44-2.63.77-3.78.89-4.17.31-1.05.36-.96.65-1.97.42-1.45.58-2.53.84-4.25.27-1.82.4-2.74.29-3.26-.38-1.71-1.6-2.86-1.82-3.06-.53-.48-.57-.34-1.1-.83-.78-.71-1.03-1.33-1.89-2.98-1.23-2.35-1.3-2.22-1.37-2.71-.17-1.12.13-2.38.74-3.34.32-.49.76-.82 1.17-1.23.68-.69.69-2.32-.29-2.79-.36-.17-.85-.13-1.24-.14l-1.84-.03c-1.36-.03-1.73-1.4-2.71-2.09-.31-.22-.59-.35-2.5-.77-3.02-.66-3.44-.59-4.81-1.05-2.25-.75-2.76-1.5-2.91-1.74-.46-.74-.24-1.12-.48-2.1-.29-1.14-.84-1.59-3.96-4.77 0 0-.72-.73-2.54-2.67-1.74-1.84-1.98-2.14-2.18-2.67-.56-1.46.12-2.14-.08-4-.16-1.52-.77-2.53-1.75-4.15a16.476 16.476 0 0 0-4.45-4.84 14.739 14.739 0 0 0-3.25-1.76c-1.14-.43-2.29-.87-3.84-.78-.54.03-1.61.1-2.74.7-.76.4-1.3 1.31-2.09 1.6-.99.36-2.57-.74-3.41-1.16-1.41-.69-1.65-.87-1.86-1.21-.41-.69-.61-2.12.22-2.61.17-.1.37-.11.55-.18 1.17-.49.54-2.22.1-2.98-.26-.45-.69-.82-.82-1.34s-.12-1.2.33-1.55c.15-.12.34-.18.52-.24.37-.12.75-.2 1.12-.3.83-.21 1.65-.5 2.49-.63.79-.12 1.59-.16 2.39-.07.75.08 1.47.32 2.21.46.44.08.89.12 1.34.14 1.93.09 3.87.63 5.79.59.95-.02.95-.13 2.18-.16.83-.02 2.15.35 2.88-.08.22-.13.36-.34.49-.55.42-.7.71-1.48 1.03-2.23.45-1.06.42-1.11.69-1.62.34-.65.79-1.52 1.57-2.18.83-.71 1.24-.5 2.68-1.2 1.68-.81 1.41-1.22 2.66-1.75 1.79-.76 2.31.1 4.44-.65 1.03-.36.94-.57 2.75-1.33 1.02-.43 1.22-.44 2.57-.93 2.33-.86 2.59-1.16 4.26-1.73.33-.11 1.63-.55 3.35-.89 1.88-.36 5.49-1.07 6.14.16.25.48-.03 1.08-.16 1.37-.82 1.79-2.95 1.23-4.4 2.99-.68.83-.83 1.78-1.13 3.68-.22 1.37-.38 2.5.22 3.52.35.6.81.88 1.6 1.37 4.63 2.85 5.47 3.35 5.83 4.41.19.55-.02.46.28 2.17.27 1.55.44 1.59.61 2.77.24 1.66-.04 1.95.38 2.68.25.42.63.74 1.39 1.38.79.67.98.66 1.49 1.21.29.31.71.76.97 1.45.15.39.17.64.24 1.26.28 2.31.39 2.18.32 2.49-.18.83-1 1.35-2.64 2.39-.71.45-1.52.95-2.7 1.38-1.55.56-1.8.29-2.78.83a5.814 5.814 0 0 0-2.14 2.06c-.42.69-.24.73-.97 2.42-.71 1.64-1.04 1.95-1.29 2.15-.38.29-.86.42-1.81.67-1.09.28-1.97.41-2.45.48-1.06.14-1.99.26-3.26.28-1.2.01-1.49-.08-1.76.18-.57.55-.34 1.96.35 2.8.23.28.62.5 1.37.93.4.23.84.46 2.34 1.17 1.09.52 1.35.63 1.7.97.46.46.79.74 1.24 1.12 1.23 1.04 2.19 1.53 2.92 1.71.97.23 1.83.55 2.63.53 1-.02 1.1-.13 1.74-.08.33.03 1.04.12 2.67.93.49.25.65.35 2.83 1.66 1.92 1.15 2.06 1.23 2.42 1.33 1.01.28 1.54.12 2.02.61.47.48.19.89.53 1.66.81 1.89 3.76 2.38 4.04 2.42.64.1.74.01 1.66.16.97.16 1.69.29 2.38.81.28.21.73.55.97 1.17.35.9.04 1.75-.08 2.02-.37.87-.92.91-1.66 1.82-.54.67-.76 1.27-1.07 2.17-.81 2.28-.29 3.25-1.19 3.97-.2.16-.68.35-1.66.73-1.04.41-1.19.37-1.58.65-.78.56-1.11 1.35-1.21 1.62-.26.65-.07.69-.28 1.33-.32.96-.99 1.57-1.7 2.22-.25.23-.6.55-1.13.89-.87.55-1.17.49-1.66.93-.57.51-.34.76-.93 1.53-.7.91-1.12.69-1.98 1.7-.53.62-.83 1.24-1.01 1.62-.15.31-.38.79-.53 1.41-.06.23-.28 1.22-.04 2.59.33 1.89 1.15 2.29.85 3.03-.4.97-2.12 1.05-2.3 1.06Z",
  style: { "stroke": "#ff000f", "stroke-miterlimit": "10", "stroke-width": "2px", "fill": "none" }
}, null, -1);
const _hoisted_4$5 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M74.81 23.49c-.02.78.46 1.43 1.26 1.66.41.12 1.02.09 2.24.04 1.6-.07 1.77-.16 2.25-.01.88.27 1.41.89 1.69 1.23.91 1.08 1.07 2.3 1.12 2.77.12 1.02-.15 1.09-.04 2.26.1.96.28.97.57 2.3.4 1.89.11 2.24.61 3.03.41.65.62.41 1.6 1.39 1.06 1.06 1 1.52 2 2.28.35.26 1.25.95 1.82.65.2-.11.29-.29.39-.53.5-1.17.59-1.83.82-2.42.1-.26.49-1.17 1.33-1.77.97-.69 1.5-.22 2.42-.89.92-.66.62-1.28 1.5-1.87.8-.53 1.17-.11 2.68-.57.58-.18 1.55-.48 2.41-1.31.71-.68 1.04-1.42 1.25-1.91.2-.47.28-.78.57-2.1.41-1.91.62-2.86.71-3.37.16-.92.38-1.82.51-2.75.1-.71.13-1.13.47-1.53.39-.44.77-.38 1.15-.9.06-.08.53-.73.3-1.21-.06-.13-.23-.35-1.24-.52-1.05-.17-1.38-.02-2.5-.12-.69-.06-1.14-.1-1.7-.32-.75-.3-.94-.64-1.59-1.04-.71-.44-1.32-.55-2.41-.74-1.06-.19-2.43-.44-4 .04-.84.26-.69.4-1.78.81-.38.14-1.27.45-3.64.73-1.91.22-2.09.11-3.68.36-1.9.3-2.47.6-2.87 1.05-.47.53-.28.81-.85 1.53-.66.85-1.52 1.25-1.98 1.45-1.17.53-1.5.23-2.53.78-.53.28-.85.79-.86 1.5Z",
  style: { "stroke": "#ff000f", "stroke-miterlimit": "10", "stroke-width": "2px", "fill": "none" }
}, null, -1);
const _hoisted_5$4 = [
  _hoisted_2$6,
  _hoisted_3$5,
  _hoisted_4$5
];
function render$6(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$6, _hoisted_5$4);
}
const AmericasIcon = { render: render$6 };
const _hoisted_1$5 = {
  id: "Icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 128 128"
};
const _hoisted_2$5 = /* @__PURE__ */ vue.createStaticVNode('<path style="fill:none;" d="M0 0h128v128H0z"></path><path d="M63.37 36.77c-.61 1.32 1.95 4.32 1.71 5.5-.03.15-.08.29-.08.29-.16.37-.55.63-1.76 2.27-1.32 1.78-1.12 1.84-1.69 2.33-.87.77-1.8 1.05-3.65 1.61-1.12.34-1.38.32-2.42.71-1.33.5-2 .76-2.34 1.41-.48.94 0 2.08.12 2.34.49 1.14 1.2 1.13 1.5 2.12.29.98-.13 1.9-.27 2.19-.47 1.02-1.61 2.26-2.85 2.1-1.18-.15-1.83-1.71-2.8-2.28-.54-.31-1.14-.53-1.7-.79-1.1-.51-2.2-1.07-3.26-1.67-2.15-1.23-1.36-2.72-2.5-4.52-.26-.41-.85-1.34-1.93-1.64-1.14-.31-2.17.27-2.78.62-1.21.68-1.17 1.2-2.76 2.76-1.8 1.77-2.46 1.7-2.82 2.79-.3.91-.25 1.99-.3 2.93-.03.49 1.2 3.44.94 3.88-.3.51-1.46-.89-2-.91-.26 0-1.21-.83-1.43-.91-2-.71-2.39-4.04-2.58-5.8-.28-2.5.24-3.43-.6-4.4-.78-.91-1.49-.4-3.14-1.3-1.03-.57-1.59-1.47-2.32-2.35-1.12-1.36-2.78-2.24-3.84-3.59-.98-1.24-1.28-3.52-.36-4.84.05-.08.02-.02 1.94-1.55 1.22-.97 1.45-1.16 1.94-1.31.86-.25 1.32 0 1.63-.37.36-.43-.07-.96.11-1.71.18-.76.84-1.17 1.89-1.81 1.4-.85 2.44-1.48 3.88-1.52 2.03-.05 3.24 1.12 3.87.51.4-.39-.02-.92.44-1.77.4-.73.88-.66 1.74-1.42 1.06-.95.83-1.52 1.77-2.43.46-.44.61-.39 2.34-1.25 2.86-1.42 2.95-1.79 4.08-1.92 1.06-.12 1.9-.21 2.66.23.21.12.51.35.93.33.59-.02 1-.47 1.08-.56.42-.47.16-.86.41-1.09.53-.48 1.72.96 3.85 1.18 1.2.12 1.63-.25 2.8.13.75.25.71.44 1.54.73.37.13 1.56.53 2.94.27 1.16-.22 1.2-.67 2.14-.65.23 0 .75.12 1.8.35.93.2 1.24.29 1.57.12.16-.08.24-.18.68-.95.47-.82.68-1.26.99-1.79.4-.69.6-1.03.75-1.14 1.04-.78 2.8.06 3.1.2.52.24.95.45 1.26.93.47.73.07 1.21.53 2 .16.27.57.58 1.4 1.2.63.48.95.71 1.32.9.43.21 1.11.55 1.96.53 1.04-.02 1.53-.56 1.74-.35.24.25-.3 1.15-1.03 2.37-.42.69-.62 1.04-.97 1.51-1.1 1.47-1.68 1.61-2.07 2.69-.23.63-.06.64-.31 1.2-.52 1.13-1.33 1.27-1.34 1.95 0 .51.47.54.82 1.4.13.31.53 1.3.04 2.03-.49.72-1.7.93-2.26.5-.2-.15-.16-.26-.54-1.56-.17-.56-.37-1.22-.75-1.96-.23-.45-.36-.6-.52-.72-.38-.29-.69-.2-1.3-.33-1.15-.24-1.32-.82-1.92-.67-.59.15-.84.81-.86.86-.14.37-.18.98.14 1.27.34.31.75.41 1.26.76.21.14.52.46.5.77-.04.72-1.67.16-2.07 1.02ZM81.04 68.77c.62.65 1.3.99 1.74 1.2.17.08.64.25 1.59.58 1.14.4 1.32.45 1.61.67.29.22.4.38.97 1.14.64.85.96 1.28 1.19 1.55 1.13 1.33 1.5 1.41 1.38 1.75-.1.3-1 .64-1.39.62-.34-.02-1.25.06-2.06-.96-.3-.38-.26-.57-.6-.8-.41-.28-1.03-.39-1.53-.16-.65.29-.56.89-1.08 1.14-.46.22-.95-.27-2.06-.94-2-1.2-1.82-1.52-3.24-2.31-.92-.51-1.84-.89-2.99-1.66-.24-.16-.5-.36-.79-.64-.3-.29-.73-.75-1.12-1.4-.58-.96-1.32-2.73-.81-3.17.49-.42 1.49.94 3.8 1.1.58.04.91-.02 1.45 0 .2 0 .48.03.78.08.5.08 1.45.22 2.16.8.59.48.33.68 1.02 1.41ZM42.92 62.33c.02 1.2 1.38 1.44 2.37 3.17.46.81.23.87.84 2 .41.75.7 1.08 1.41 2.05 1.55 2.14 1.18 2.02 1.67 2.46.84.76.85 1.23 3.65 2.23 1.26.45 1.6.63 2.26.88 3.83 1.41 9.6.78 9.83-.18.13-.52-1.1-1.31-2.36-1.54-.92-.17-1.18.18-2.52.09-.67-.04-.67-.14-2.49-.56-1.8-.42-2.29-.61-3.3-.99-1.6-.6-1.85-1.05-1.93-1.3-.17-.48.07-.75-.17-1.28-.23-.51-.63-.67-1.09-1.02-.43-.32-.44-.44-1.54-1.85-1.36-1.75-2.17-2.64-2.41-2.9-.84-.9-1.21-1.19-1.54-1.4-.27-.18-1.78-1.17-2.4-.67-.28.22-.27.66-.27.8Z" style="stroke-miterlimit:10;stroke:#ff000f;stroke-width:2px;fill:none;"></path><path d="M55.35 64.62c2.72.83 5.14-6.16 7.79-2.86.61.83-1.84 2.23-.09 3.61-.54 1.52-2.17 2.57-2.32 4.36-2.53.08-7.93-1.91-5.38-5.11Z" style="stroke-linejoin:round;stroke:#ff000f;stroke-width:2px;fill:none;"></path><path d="M64.09 52.08c.2-.34.39-.67.73-.73.52-.1 1.03.44 1.14.63.23.39.55.79.5 1.25-.11.89-.43 1.04-.3 1.42.09.26-.12.24.86.96.32.23.48.35.64.49.2.18.72.64 1.06 1.35.32.66.37 1.28.45 2.23.03.37.01.42.05.77.1.82.24 1.01.1 1.28-.19.37-.7.47-.85.49-.36.07-.65-.02-.8-.07-.61-.19-1.21-.69-1.44-1.37-.18-.56.09-.63-.1-1.19-.21-.61-.57-.6-1-1.39-.31-.57-.15-.63-.43-1.07-.47-.73-1.38-.95-1.56-1.48-.01-.04-.02-.07-.02-.11-.02-.27.08-.47.16-.64.09-.21.11-.44.17-.67.35-1.33.3-1.63.62-2.18Z" style="stroke-miterlimit:10;stroke:#ff000f;stroke-width:2px;fill:none;"></path><path d="M78.37 80.87c1.7 1.05 2.79 2.25 3.18.72 1.27-4.89 4.04-1.41 4.86 2.06.55.61 3.61 3.15 4.41 4.19 3.64 4.49-1.23 7.62-1.92 11.95-1.35 1.33-6.16 1.63-7.76 1.27-1.07-.22-1.62-3.22-2.47-3.74-1.4-.33-2.08.04-3.03-1.38-3.73-5.55-16.48 7.88-15.85 1.17.34-3.59-3.2-9.75.36-11.78 1.84-1.13 3.93-.26 5.56-2.01 4.84-7.75 5.09-1.21 7.31-4.74 1.09-2.06 3.69-1.85 4.31.22-.28 1.32-.56 1.41 1.02 2.06Z" style="stroke-linejoin:round;stroke:#ff000f;stroke-width:2px;stroke-linecap:round;fill:none;"></path><path d="M84.65 105.87c.06.43.19 1.33.9 1.67.54.26 1.1.04 1.22 0 .92-.36 1.15-1.39 1.18-1.56.06-.29.16-.74-.05-1.15-.38-.75-1.32-.3-1.5-.32-.24-.03-1.08-.68-1.55-.12-.36.44-.27 1.01-.2 1.49Z" style="stroke-miterlimit:10;stroke:#ff000f;stroke-width:2px;fill:none;"></path><path d="M109.08 98.69c.71-1.05 1.38-.24 1.97.6.27.39.62.74 1.01 1 1.42.97 1.41 1.1-.43 2.5-.77.74-2.65 2.27-2.89 2.76-1.17 1.53-4.51 6.4-6.1 3.7-.82-1.39.63-2.55 2.04-3.61.8-.6 1.51-1.31 2.12-2.1 1.14-1.48 1.98-2.34 2.28-4.85Z" style="stroke-linejoin:round;stroke:#ff000f;stroke-width:2px;stroke-linecap:round;fill:none;"></path><path d="M72.6 40.59c-.34-.53 1.58-2.81 3.88-4.23.73-.45 1.59-.86 2.66-1.84 1.13-1.03 1.35-1.63 1.43-1.93.19-.71-.07-.86.05-2.08.06-.62.13-1.34.53-2.1.29-.55.71-1.35 1.44-1.46.68-.1 1.23.47 2.06 1.33.52.54.56.77.53.92-.06.29-.38.32-.88.81 0 0-.37.36-.65.85-.24.42-.04.7-.21 1.35-.23.9-.39 1.52-.65 2.1-.32.71-.96 1.19-1.15 1.4-.81.95-1.33 1.79-2.77 2.52-1.09.55-1.19.48-1.8.9-.89.6-.98.95-1.7 1.35-.87.49-2.55.43-2.77.08Z" style="stroke-miterlimit:10;stroke:#ff000f;stroke-width:2px;fill:none;"></path>', 8);
const _hoisted_10 = [
  _hoisted_2$5
];
function render$5(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$5, _hoisted_10);
}
const AsiaPacificIcon = { render: render$5 };
const _hoisted_1$4 = {
  id: "Icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 128 128"
};
const _hoisted_2$4 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none" },
  d: "M0 0h128v128H0z"
}, null, -1);
const _hoisted_3$4 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M79.88 56.7c.36-1.09.08-2.34 0-2.62-.05-.23-.1-.43-.21-.69-.21-.5-.44-.69-.59-1.43-.19-.97-.01-1.73.35-3.21.21-.86.33-2.02.93-2.71.4-.46.94-.75 1.51-.94.46-.16.97-.25 1.35-.57.71-.59.88-1.8 1.3-2.59.41-.76 1.14-1.08 1.39-1.19 1.37-.6 2.64 0 2.86.11.35.17 1.32.66 1.36 1.39.03.6-.6.93-1.66 1.85-.58.5-1.41.94-2.33 2.39-.48.76-.8.78-.83 2.27-.01.59.04 2.01.75 2.84 1.27 1.47 4.3.66 6.14.17 2.09-.56 3.41-1.43 4.95-2.45.1-.07.88-.59 2.29-1.65.95-.71.78-1.38.68-1.68-.16-.45-.59-.33-1.06-.93-.31-.4-.42-.89-.65-1.87-.05-.22-.12-.53-.18-.95-.22-1.54.09-1.87-.06-2.73-.27-1.62-1.56-1.84-1.36-2.87.14-.7.79-.83.84-1.69.04-.52-.17-.94-.32-1.22-.56-1.13-1.4-1.2-1.44-1.82-.03-.57.69-.63 1.13-1.55.43-.9.34-2.11-.28-2.87-.28-.35-.69-.56-1.42-.82-1.29-.46-2.89-.27-4.23-.17-.91.07-2.58 1.27-5.87 1.92-2.84.56-4.29.85-5.34 1.45-1.43.81-2.29 1.77-3.39 3.02-.66.74-1.64 2.15-3.61 4.97-.75 1.07-1.1 1.59-1.75 2.37-.99 1.18-1.16 1.16-2.32 2.45-1.75 1.96-1.71 2.39-2.79 3.11-.2.13-.95.47-2.45 1.13-.9.4-2.14.72-2.81 1.46-.43.48-.57 1.09-.64 1.71-.15 1.38-.12 7.73 1.73 8.32.48.15.81-.23 1.92-.81 1.01-.53 3.07-1.8 4.2-.92.5.39.58 1.1.59 1.22 0 .05.05.87-.51 1.43-.37.37-.63.26-1.73.66-.88.32-1.33.48-1.58.86-.08.13-.2.35-.12 1.7.08 1.31.12 1.96.31 2.59.19.6.4.96.33 1.57-.03.31-.07.63-.29.88-.48.55-1.21.11-2.49.53-.46.15-.91.3-1.31.71-.59.61-.41 1.14-1.09 2.05-.19.24-.22.24-.87.87-.79.77-1.2 1.24-1.6 1.66-.33.35-1.59 1.67-2.8 2.52-1.59 1.12-4.04 2.12-6.5 2.19-1.18.03-1.76.21-2.91.55 0 0-1.11.33-1.46 1.03-.05.1-.08.2-.04.29.1.27.67.28.84.28.86.04 2.5.46 3.33 1.22.82.76.41 1.43 1.24 2.93.11.21.44.76.42 1.51 0 .04 0 .12-.02.21-.14 1.08-1.19 1.75-1.26 1.79-.68.42-1.36.44-1.71.44-.09 0-.3 0-.63-.04-.97-.12-1.6-.44-2.04-.6-.58-.21-1.29-.21-2.72-.2-1.57.01-2.37.02-2.86.47-.64.58-.69 1.46-.7 1.63-.07 1.09.61 1.41.77 2.41.23 1.42-.96 1.76-1.17 3.43-.3 2.38 1.79 4.35 1.99 4.53 1.23 1.13 2.6 1.42 3.1 1.52.98.2 1.72.11 2.65 0 1.57-.19 3.43-.42 5.04-1.79.62-.53 1.64-1.4 1.7-2.62.04-.66-.24-.91-.07-1.55.26-1 1.25-1.59 1.62-1.81.58-.35 1.34-.61 2.22-1.19.09-.06.25-.17.39-.35.33-.44.22-.87.3-1.29.16-.86 1.08-1.45 1.65-1.65.72-.26.89.11 2.12.08.41-.01 1.66-.04 2.82-.74.93-.56.89-1 1.62-1.19.95-.25 1.85.27 2.12.43 1.1.64.72 1.19 2.1 2.45.65.6 1.66 1.33 2.12 1.86.04.04.25.29.56.63.14.15.22.23.3.31.56.55.84.63 1.11 1.09.03.05.06.1.09.17.29.67 0 1.39-.2 1.86-.11.26-.21.44-.3.61-.34.61-.65.93-.77 1.1-.59.82-.13 2.89.85 3.29 1.36.56 3.44-2.22 4.08-3.07.66-.88 1.76-2.4 1.33-3.95-.05-.18-.1-.3-.16-.42-.57-1.29-1.58-1.69-3.33-2.87-1.56-1.06-2.84-2.15-3.52-3.43-.05-.09-.12-.24-.2-.43-.45-1.13-.57-2.76.01-3.17.74-.52 2.63 1.02 3.55 1.77 2.19 1.79 2.5 2.99 5.17 5.09.95.75.85.54 1.17.88 1.94 1.96.8 4.2 2.47 7.13.48.84 1.15 2.02 2.45 2.38 0 0 1.29.36 3.74-.93.11-.06.29-.17.4-.37.16-.29.09-.62.08-.7-.12-.66.38-1.9.94-2.48 1.08-1.12 3.21-.59 3.9-1.63.05-.07.09-.15.09-.15.31-.56.22-.97.3-1.75.05-.56.17-1.05.23-1.32.04-.18.12-.48.19-.92 0 0 .04-.24.07-.46.05-.35.14-1.06.09-1.85-.07-.98-.31-1.26-.12-1.94.02-.05.08-.26.2-.49.63-1.19 2.37-1.86 3.73-1.56.23.05.45.1.7.24.48.27.69.66 1.28 1.05.11.07.21.13.25.15 0 0 .31.16.66.27 2.63.79 3.74-.3 3.74-.3.53-.52.88-1.42.67-2.18-.25-.91-1.15-1.12-1.05-1.63.1-.49 1-.71 1.9-.94.89-.23 1.04-.11 1.8-.32.7-.19 1.4-.39 1.98-.95.62-.6.3-.85 1.26-2.55.3-.53.45-.72.38-.99-.12-.44-.69-.5-1.65-1.12-.74-.47-.59-.56-1.04-.79-1.26-.67-2.06.2-3.26-.38-.05-.03-.55-.5-1.53-1.44-1.09-1.05-1.18-1.14-1.44-1.28-.89-.49-1.18-.15-2.09-.63-.91-.48-1.23-1.14-1.51-1.01-.28.13-.27.88-.12.94.21.07.97-1.05.99-2.28 0-.5.01-.82-.21-1.09-.36-.45-1.06-.47-1.37-1.05-.04-.08-.08-.18-.08-.18-.16-.42-.12-.79-.11-.89.03-.53-.37-1.09-.63-1.45-.89-1.25-3.12-1.35-3.15-1.24-.03.11 1.71.62 1.72.6.01-.03-2.11-.37-2.8-1.8-.15-.31-.22-.77-.38-1.7-.12-.76-.19-1.14-.14-1.61.08-.77.33-.94.23-1.38-.13-.54-.67-.84-1.05-1.05-.21-.12-1.86-.99-3.45-.19-.24.12-1.17.59-1.34 1.44-.05.26 0 .34.13 1.12.19 1.2.28 1.81.03 2.03-.22.2-.63.08-1.43-.16-1.37-.4-1.47-.72-2.11-.69-1 .05-1.68.9-1.71 1.15 0 .01-.01.17-.03.36 0 .11-.01.19-.01.22-.02.31-.08 1.17-.09 1.26-.09 1.13-.23 2.95-1.26 3.75-.57.44-.77.07-3.21.44-1.25.19-1.36.31-2.71.48-1.14.14-1.86.16-2.64.05-.87-.12-1.55-.22-1.87-.77-.25-.43-.24-1.12.09-1.38.44-.35 1.07.36 1.97.05.49-.16.4-.4 1.15-.87.73-.46 1.01-.36 1.69-.73.25-.14 1.06-.59 1.48-1.39.58-1.12-.25-1.71.23-2.95.43-1.13 1.21-.87 1.61-2.08ZM36.64 71.03c.07-.38.14-.75.21-1.12.12-.6.18-1.19.18-1.8 0-.49-.03-.98-.03-1.48 0-1.08 1-1.08 1.9-1.5.28-.13 1.23-.8 1.5-.96.77-.43 1.37.52 1.7 1.08.5.86.57 1.84.59 2.81s-.14 1.94-.72 2.75c-.4.56-1 1.08-1.71 1.15-.34.03-.69.02-1.04.04-.5.03-1 .1-1.49.18-.28.05-1.06.31-1.2-.1-.08-.22.04-.56.07-.78.02-.09.03-.17.05-.26Z",
  style: { "stroke": "#ff000f", "stroke-miterlimit": "10", "stroke-width": "2px", "fill": "none" }
}, null, -1);
const _hoisted_4$4 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M42.66 58.42c-.06-1.39 1.54-2.37 2.66-2.8.42-.16 1.42-.54 1.92-.09.32.29.34.81.37 1.49.04.89-.34 2.02.26 2.78.32.4.69.72.91 1.2.11.22.19.45.21.69.02.19 0 .38.02.56.1 1.07.91 1.96 1.47 2.83.56.88.77 1.27 1.37 2.12.4.56.8 1.14 1.46 1.39.21.08.44.12.66.18.16.04.33.1.43.24.22.33-.02.8-.2 1.09-.76 1.22-1.99 1.78-3.32 2.14-1 .27-.94.08-2.12.35-1.48.34-2.92.92-4.2 1.72-.21.13-.41.27-.61.4-.11.07-.23.17-.36.2-.28.08-.12-.35-.07-.47.22-.53.55-1.02.87-1.51a49.8 49.8 0 0 1 1.96-2.79c.6-.81 1.18-1.73.95-2.78-.12-.59-.55-1.11-.87-1.6-.11-.17-.22-.35-.34-.52-.36-.51-.73-1.04-1.09-1.55-.13-.18-.25-.37-.39-.54-.05-.06-.1-.11-.16-.17-.28-.28-.53-.58-.69-.95s-.2-.75-.3-1.13c-.22-.81-.75-1.61-.81-2.49ZM18.24 38.74c.18.09.58.29.88.74.4.6.18.98.54 1.25.38.29.96.11 1.14.06.62-.19.65-.55 1.27-.89.31-.17.8-.23 1.8-.36.67-.08 1.21-.12 1.84-.16.94-.06 1.02.05 1.35-.07.77-.28.79-.87 1.31-.9.4-.02.73.31 1.39.96.41.41.32.42.75.85.63.63.87.66 1.12 1.11.11.19.34.61.22 1.05-.07.28-.23.41-.81.92-1.01.9-.9.84-1.06.95-.5.33-.95.43-1.83.62-1.61.34-1.82.1-2.45.48-.77.46-.6.91-1.24 1.1-.48.14-.64-.09-2.05-.11-.22 0-.37 0-.66-.01-.41-.02-.86-.04-1.23-.13-.76-.18-.68-.51-1.36-.71-.86-.26-1.25.19-1.71-.17-.36-.28-.52-.86-.37-1.26.16-.43.65-.56.6-.69-.05-.14-.66.14-1.39-.06-.16-.04-.76-.2-1.09-.75-.22-.36-.21-.73-.2-1.04 0-.28.02-.82.4-1.29.26-.32.59-.48.68-.52.37-.17.47-.08.67-.23.38-.29.21-.75.52-.93.27-.15.64.03.96.19Z",
  style: { "stroke": "#ff000f", "stroke-miterlimit": "10", "stroke-width": "2px", "fill": "none" }
}, null, -1);
const _hoisted_5$3 = [
  _hoisted_2$4,
  _hoisted_3$4,
  _hoisted_4$4
];
function render$4(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$4, _hoisted_5$3);
}
const EuropeIcon = { render: render$4 };
const _hoisted_1$3 = {
  id: "Icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 128 128"
};
const _hoisted_2$3 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none" },
  d: "M0 0h128v128H0z"
}, null, -1);
const _hoisted_3$3 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M61.42 108.22c-2.17-.9-.33-5.46-2.86-11.6-1.36-3.3-2.09-2.46-5.23-7.92-2.98-5.19-2.4-6.08-5.17-10.23-2.05-3.07-2.61-2.94-4.95-6.56-1.75-2.7-2.93-4.53-3.76-7.33-.56-1.86-1.51-5.06-.73-8.78.59-2.79 3.71-5.81 3.1-8.7a5.961 5.961 0 0 0-1.69-3.01c-.74-.7-1.74-1.23-2.78-1.11-.84.1-1.58.6-2.39.82-1.12.31-2.3.14-3.35-.31-.85-.37-1.61-.87-2.58-.77-1.05.1-1.58.91-2.52 1.23-2.09.71-4.78-2.15-6.16-3.37-5.27-4.62-5.37-6.01-5.36-6.57.04-1.9 1.46-3.2 1.52-3.25 1.45-1.29 2.68-.5 5.85-1.3 1.23-.31.9-.39 6.07-2.6 2.26-.97 3.39-1.45 3.69-1.52 2.66-.62 4.88.08 9.01 1.44 3.34 1.1 6.46 2.59 10.03 2.78.85.05 1.76.02 2.53-.38.91-.48 1.98-1.2 2.22-2.26.65-2.98-4.39-3.78-4.1-6.36.06-.57.36-.8.89-.83 1.14-.07 2.34.34 3.32.89.58.32 1.11.72 1.7 1.03 2.37 1.26 5.52 1.93 8.11 2.67 2.14.61 4.25 1.29 6.39 1.89 1.51.42 2.32.63 3.29 1.32.19.13 1.6 1.14 2.36 2.66 1.83 3.65-1.81 6.72-.15 9.52.98 1.65 3.13 2.09 5.18 2.51.98.2 3.57.73 6.23-.4 1.74-.74 2.48-2.4 4.03-3.34 3.26-1.98 7.68-.98 10.71.96 1.2.77 2.58 1.65 3.1 3.28.53 1.64-.24 2.7-.78 5.91-.31 1.85-.34 3.15-.38 5.35-.09 4.49-.13 6.73.82 8.2 1.36 2.11 4.13 2.29 5.48 4.41 1.29 2.04 1.23 5.02-.76 6.6-.96.76-2.19 1.15-3.38 1.37-3.05.55-6.28-2.08-9.08-3.04-3.5-1.2-8.02-2.12-9.32-2.39-2.43-.49-4.09-.73-5.42-2.17-1.02-1.11-.75-1.75-1.95-3.9-1.09-1.97-2.5-4.5-4.34-4.55-2.01-.06-3.81 2.89-4.34 5.2-.48 2.09.06 3.77.65 5.64.71 2.25 1.54 4.87 4.12 6.72.47.33 3.4 2.45 6.47 1.72 1.45-.34 3.41-1.43 3.94-1.72 1.53-.85 1.97-1.33 2.88-1.29.87.04 1.04.5 2.97 1.72.7.45 2.05 1.26 3.69 1.95 1.62.69 1.67.47 2.65.97.64.33 3.19 1.62 3.42 3.34.2 1.46-1.42 2.13-4.47 5.31-4.02 4.2-3.76 5.73-6.18 6.56-2.38.82-3.51-.36-5.61.94-1.21.75-1.23 1.39-3.08 3.24-.93.94-2.22 2.24-3.72 3.07-3.33 1.85-4.99-.08-9.25 1.49-1.51.56-1.04.71-4.77 2.6-3.35 1.71-5.05 2.55-5.83 2.23Z",
  style: { "stroke": "#ff000f", "stroke-miterlimit": "10", "stroke-width": "2px", "fill": "none" }
}, null, -1);
const _hoisted_4$3 = [
  _hoisted_2$3,
  _hoisted_3$3
];
function render$3(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$3, _hoisted_4$3);
}
const MiddleEastIcon = { render: render$3 };
const _hoisted_1$2 = {
  id: "Icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$2 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none" },
  d: "M0 0h140v140H0z"
}, null, -1);
const _hoisted_3$2 = /* @__PURE__ */ vue.createElementVNode("rect", {
  x: "34.24",
  y: "35.16",
  width: "71.51",
  height: "74.84",
  rx: "2.77",
  ry: "2.77",
  style: { "stroke": "gray", "stroke-miterlimit": "10", "stroke-width": "1.5px", "fill": "none" }
}, null, -1);
const _hoisted_4$2 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "stroke": "gray", "stroke-miterlimit": "10", "stroke-width": "1.5px", "fill": "none" },
  d: "M70 30v10.31M52.12 30v10.31M87.88 30v10.31M58.01 51.16h37.1M58.01 57.35h28.78M45.94 51.16h6.19v6.19h-6.19zM58.01 71.6h37.1M58.01 77.79h20.46M45.94 71.6h6.19v6.19h-6.19zM58.01 92.05h37.1M58.01 98.23h20.46M45.94 92.05h6.19v6.19h-6.19z"
}, null, -1);
const _hoisted_5$2 = [
  _hoisted_2$2,
  _hoisted_3$2,
  _hoisted_4$2
];
function render$2(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$2, _hoisted_5$2);
}
const FormPlaceholderIcon = { render: render$2 };
const _hoisted_1$1 = {
  id: "Icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
const _hoisted_2$1 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill": "none" },
  d: "M0 0h140v140H0z"
}, null, -1);
const _hoisted_3$1 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M92.13 92.65 81.49 79.97c-2.56-3.06-7.12-3.45-10.18-.89l-5.95 5c-1.18.99-2.92.87-3.98-.25a39.748 39.748 0 0 1-5.3-7.17l-1.55-2.69c-1.85-3.2-2.95-6.17-3.57-8.19-.45-1.47.35-3.04 1.8-3.57l7.28-2.65c3.75-1.36 5.68-5.51 4.32-9.26L58.7 34.75c-1.36-3.75-5.51-5.68-9.26-4.32l-3.8 1.38s-25.98 7.69-5.85 48.85c.45.93.95 1.85 1.47 2.74.52.9 1.06 1.79 1.64 2.65 25.59 38.02 45.23 19.36 45.23 19.36l3.1-2.6c3.06-2.56 3.45-7.12.89-10.17ZM98.57 75.58c4.72-16.43-4.75-33.54-21.18-38.27",
  style: { "stroke": "gray", "stroke-miterlimit": "10", "stroke-width": "1.5px", "fill": "none" }
}, null, -1);
const _hoisted_4$1 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M89.82 75.58c3.78-13.14-3.8-26.84-16.95-30.61M106.39 76.11c5.67-19.72-5.7-40.25-25.42-45.92",
  style: { "stroke": "gray", "stroke-miterlimit": "10", "stroke-width": "1.5px", "fill": "none" }
}, null, -1);
const _hoisted_5$1 = [
  _hoisted_2$1,
  _hoisted_3$1,
  _hoisted_4$1
];
function render$1(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$1, _hoisted_5$1);
}
const PhonePlaceholderIcon = { render: render$1 };
const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ vue.createElementVNode("path", { d: "M8.033 11.62H3.56c-.912 0-1.662.781-1.662 1.753v16.15c0 .963.74 1.754 1.662 1.754h4.463c.912 0 1.662-.781 1.662-1.754v-16.15c0-.972-.741-1.754-1.653-1.754zm.162 17.465c0 .305-.235.553-.524.553H3.913c-.289 0-.524-.248-.524-.553V13.783c0-.305.235-.553.524-.553H7.68c.29 0 .524.248.524.553v15.302z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ vue.createElementVNode("path", {
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "fill": "#010101" },
  d: "M24.24 18.4h3.44v3.44h-3.44zM17.47 18.4h3.44v3.44h-3.44zM24.24 25.12h3.44v3.44h-3.44zM17.47 25.12h3.44v3.44h-3.44zM31.28 13.97v-5.2c0-.26-.09-.43-.26-.61l-6.07-6.07a.8.8 0 0 0-.61-.26h-8.67c-.95 0-1.73.78-1.73 1.73v10.9zM24.34 3.91l4.86 4.86h-4.86zm-8.67 10.24V3.56h6.94v5.2c0 .95.78 1.73 1.73 1.73h5.2v3.08z",
  transform: "matrix(.90333 0 0 .95335 .128 -1.165)"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M31.91 13.23H13.32c-.71 0-1.29.58-1.29 1.29V32.9c0 .71.58 1.28 1.28 1.28H31.9c.71 0 1.28-.57 1.28-1.28V14.51c.01-.71-.56-1.28-1.27-1.28zm-.5 19.22h-17.6V15.02h17.6z",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd" },
  transform: "matrix(.90333 0 0 .95335 .128 -1.165)"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function render(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1, _hoisted_5);
}
const FaxIcon = { render };
const icons = {
  install: (app, ...options) => {
    app.component("arrow-left", ArrowLeft);
    app.component("arrow-right", arrowRight.ArrowRight);
    app.component("arrow-angle", ArrowAngle);
    app.component("chevron-down", ChevronDown);
    app.component("chevron-up", ChevronUp);
    app.component("chevron-right", chevronLeft.ChevronRight);
    app.component("chevron-left", chevronLeft.ChevronLeft);
    app.component("arrow-down", ArrowDown);
    app.component("arrow-up", ArrowUp);
    app.component("twitter-icon", TwitterIcon);
    app.component("linkedin-icon", LinkedinIcon);
    app.component("facebook-icon", FacebookIcon);
    app.component("search-icon", search.SearchIcon);
    app.component("globe-icon", GlobeIcon);
    app.component("tick-icon", TickIcon);
    app.component("close-icon", close.CloseIcon);
    app.component("plus-icon", PlusIcon);
    app.component("burger-icon", burger.BurgerIcon);
    app.component("play-icon", play.PlayIcon);
    app.component("phone-icon", PhoneIcon);
    app.component("email-icon", EmailIcon);
    app.component("linkout-icon", LinkoutIcon);
    app.component("pin-icon", PinIcon);
    app.component("document-icon", DocumentIcon);
    app.component("upload-icon", upload.UploadIcon);
    app.component("right-icon", RightIcon);
    app.component("info-circle-icon", InfoCircleIcon);
    app.component("minus-icon", MinusIcon);
    app.component("chat-icon", ChatIcon);
    app.component("expand-icon", ExpandIcon);
    app.component("reduce-icon", ReduceIcon);
    app.component("favourite-filled-icon", FavouriteFilledIcon);
    app.component("favourite-outlined-icon", FavouriteOutlinedIcon);
    app.component("home-icon", HomeIcon);
    app.component("minus-circle-icon", MinusCircleIcon);
    app.component("news-icon", NewsIcon);
    app.component("plus-circle-icon", PlusCircleIcon);
    app.component("profile-icon", ExtrudedProfileIcon);
    app.component("extruded-profile-icon", ExtrudedProfileIcon);
    app.component("recycle-icon", RecycleIcon);
    app.component("rod-icon", RodIcon);
    app.component("sales-quote-icon", SalesQuoteIcon);
    app.component("sales-quote2-icon", SalesQuote2Icon);
    app.component("sample-icon", SampleIcon);
    app.component("settings-icon", SettingsIcon);
    app.component("sheet-icon", SheetIcon);
    app.component("plate-icon", PlateIcon);
    app.component("tube-icon", TubeIcon);
    app.component("tubular-bar-icon", TubularTubeIcon);
    app.component("zoom-icon", ZoomIcon);
    app.component("wechat-icon", WechatIcon);
    app.component("youku-icon", YoukuIcon);
    app.component("africa-icon", AfricaIcon);
    app.component("americas-icon", AmericasIcon);
    app.component("asia-pacific-icon", AsiaPacificIcon);
    app.component("europe-icon", EuropeIcon);
    app.component("middle-east-icon", MiddleEastIcon);
    app.component("phone-placeholder-icon", PhonePlaceholderIcon);
    app.component("form-placeholder-icon", FormPlaceholderIcon);
    app.component("fax-icon", FaxIcon);
  }
};
exports.ArrowRight = arrowRight.ArrowRight;
exports.ChevronLeft = chevronLeft.ChevronLeft;
exports.ChevronRight = chevronLeft.ChevronRight;
exports.SearchIcon = search.SearchIcon;
exports.CloseIcon = close.CloseIcon;
exports.BurgerIcon = burger.BurgerIcon;
exports.PlayIcon = play.PlayIcon;
exports.UploadIcon = upload.UploadIcon;
exports.AfricaIcon = AfricaIcon;
exports.AmericasIcon = AmericasIcon;
exports.ArrowAngle = ArrowAngle;
exports.ArrowDown = ArrowDown;
exports.ArrowLeft = ArrowLeft;
exports.ArrowUp = ArrowUp;
exports.AsiaPacificIcon = AsiaPacificIcon;
exports.ChatIcon = ChatIcon;
exports.ChevronDown = ChevronDown;
exports.ChevronUp = ChevronUp;
exports.DocumentIcon = DocumentIcon;
exports.EmailIcon = EmailIcon;
exports.EuropeIcon = EuropeIcon;
exports.ExpandIcon = ExpandIcon;
exports.ExtrudedProfileIcon = ExtrudedProfileIcon;
exports.FacebookIcon = FacebookIcon;
exports.FavouriteFilledIcon = FavouriteFilledIcon;
exports.FavouriteOutlinedIcon = FavouriteOutlinedIcon;
exports.FaxIcon = FaxIcon;
exports.FormPlaceholderIcon = FormPlaceholderIcon;
exports.GlobeIcon = GlobeIcon;
exports.HomeIcon = HomeIcon;
exports.InfoCircleIcon = InfoCircleIcon;
exports.LinkedinIcon = LinkedinIcon;
exports.LinkoutIcon = LinkoutIcon;
exports.MiddleEastIcon = MiddleEastIcon;
exports.MinusCircleIcon = MinusCircleIcon;
exports.MinusIcon = MinusIcon;
exports.NewsIcon = NewsIcon;
exports.PhoneIcon = PhoneIcon;
exports.PhonePlaceholderIcon = PhonePlaceholderIcon;
exports.PinIcon = PinIcon;
exports.PlusCircleIcon = PlusCircleIcon;
exports.PlusIcon = PlusIcon;
exports.ProfileIcon = ExtrudedProfileIcon;
exports.RecycleIcon = RecycleIcon;
exports.RightIcon = RightIcon;
exports.RodIcon = RodIcon;
exports.SalesQuote2Icon = SalesQuote2Icon;
exports.SalesQuoteIcon = SalesQuoteIcon;
exports.SampleIcon = SampleIcon;
exports.SettingsIcon = SettingsIcon;
exports.SheetIcon = SheetIcon;
exports.TickIcon = TickIcon;
exports.TubeIcon = TubeIcon;
exports.TubularTubeIcon = TubularTubeIcon;
exports.TwitterIcon = TwitterIcon;
exports.WechatIcon = WechatIcon;
exports.YoukuIcon = YoukuIcon;
exports.ZoomIcon = ZoomIcon;
exports.default = icons;
